import { Component, HostListener, OnInit, ViewEncapsulation, ElementRef, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../login/login.service';
import { ClassManageService } from './classmanage.service';
import { GroupService } from '../groups/groups.service';
import { AppSettings } from '../../config/config';
import { FormValidator } from '../form.validator';
import { Offcanvas } from '../form.offcanvas';
import { ScriptLoader } from '../script-loader';
import { CdkDragDrop, moveItemInArray, CdkDragEnter } from '@angular/cdk/drag-drop';
import * as classStrings from "../stringFiles/classManage.json";
import { firstValueFrom } from 'rxjs';
import * as registrationStrings from "../stringFiles/registration.json";
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { BrandService } from '../brand/brand.service';

declare var $: any;
declare var jquery: any;
declare var d3: any;
declare var customToastr: any;
declare var momentJs: any;

@Component({
  selector: 'app-classmanage',
  templateUrl: './classmanage.component.html',
  styleUrls: [
    './../../assets/css/theme-default/bootstrap.css',
    './../../assets/css/theme-default/materialadmin.css',
    './../../assets/css/theme-default/font-awesome.min.css',
    './../../assets/css/theme-default/libs/bootstrap-datepicker/datepicker3.css',
    './../../assets/css/theme-default/libs/DataTables/jquery.dataTables.css',
    './../../assets/css/theme-default/libs/DataTables/extensions/dataTables.colVis.css',
    './../../assets/css/theme-default/material-design-iconic-font.min.css',
    './../../assets/css/theme-default/libs/DataTables/extensions/dataTables.tableTools.css',
    './../../assets/css/theme-default/libs/bootstrap-tagsinput/bootstrap-tagsinput.css',
    /*'./../../assets/css/theme-default/libs/toastr/toastr.css?1425466569',*/
    './../../assets/css/theme-default/libs/nestable/nestable.css',
    './../../assets/css/theme-default/libs/jquery-ui/jquery-ui-theme.css',
    './../../css/timepicker.css',
    './classmanage.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [LoginService, ClassManageService, GroupService, FormValidator, Offcanvas, ScriptLoader],
})
export class ClassmanageComponent implements OnInit {
  private langChangeSubscription: any;
  isTimetableNotConfigured: boolean;
  private classIdForTranslations: any;
  private dataRowForTranslations: any;
  academicId = 0;
  getAuthToken = localStorage.getItem('usertoken');
  getSchoolId = localStorage.getItem('schoolinfo');
  selectedStaff: any = null;
  isStaffHasPermissionToViewStudentFees: boolean = false; 
  

  classesListToDrag: any = [];
  sectionsListToDrag: any = [];
  standardIdSelectedToDrag: any;

  enableClassSequence = false;
  enableSectionSequence = false;

  //category
  getCategoryListArray = [];
  getViewCatName;
  getViewttclasses;
  getViewttsections;
  getViewttstudents;
  getViewcatid;
  getCategoryClassListArray = [];
  classStandardName;
  getCategoryClassListtotalSections;
  getCategoryClassListtotalStudents;
  getCategoryClassListclassId;
  getCategoryClassListclassIdView;
  getClassListclassId;
  editCategoryCategoryClassName;
  updateClassStdName = { className: '' };

  addNewCategoryCategoryName = '';
  editCategoryCategoryName = '';

  //class
  getSectionNameInClass = '';
  getClassListArray = [];
  getClassListCatId;
  getClassViewClassSectionArray = [];
  getSeletedSectionClassIdView;
  getSeletedSectionSectionId;
  getClassSectionStudentListArray = [];
  addNewSectionStatus = false;
  getNewSectionName = '';
  getClassStandardIdList;
  getSectiondIdClass = '';
  getClassStdId = '';
  classStdId = '';
  //subjects
  getSubjectListArray = [];
  getViewsubjectName;
  getViewsubjectCategoryName;
  getViewsubjectBelonging;
  getSubjectListViewArray = [];
  classCategory = [];
  classStandards = [];
  classCategoryDetailList = [];
  schoolCategories = [];
  viewClassCategoryId = 0;
  viewClassCategorytotalclasses = 0;
  viewClassCategorytotalsection = 0;
  viewClassCategorytotalStudents = 0;
  viewClassCategoryName = null;
  newCategoryName = null;
  getSubjectId = '';
  newStandardName = null;
  newStandardSections = [];
  //view standards
  viewStandardName = null;
  viewStandardcategoryName = null;
  viewStandardcategoryId = null;
  viewStandardtotalSections = 0;
  viewStandardtotalStudents = 0;
  viewStandardtotalStaffs = 0;
  viewStandardId = '';
  viewStandardIdInClass = '';
  viewStandardSections = [];
  selectedClassId = '';
  selectedCatIdAddSection = 0;
  selectedSectionIdViewStandards = 0;
  selectedStatuaViewStandards = null;
  classlistbycat = [];
  sectionId = '';
  subjectList = [];
  classSectionId = '';
  teacherList = [];
  staffsList = [];
  delTeacherId;
  delTeacherPos;
  addSub = { subjectname: '' };
  teacher = { searchTeacher: '' };
  sectionDetail: any = { categoryId: '' };
  permissions: any = { SCHOOL_STUDENT_MANAGEMENT: '', SCHOOL_STAFFS_MANAGEMENT: '' };
  period: number;
  getCategoryId = '0';

  //staff list
  subjectHtml = '';
  staffTitle = 'Teacher';
  notAssigned = 'NA';
  staffOptions: any;
  staffImageToRemoveTimeSlot;
  showTimeslot = '';
  showClass = '';
  removeStaffTimeSlotPeriod = [];
  copyEscape = false;

  copiedTimeTableSlotData = { subjectId: null, staffId: null };
  copiedTimeTableSlotDataReset = { subjectId: null, staffId: null };

  subjectListNotInClass = [];
  editClassTeacher = null;
  /*
  * TImetable slot clash with other class
  * */
  openTimetableTimeClashPopup = false;
  fullMessageHTMLString = '<div></div>';
  showTimeSlotClashed;
  showClassClashed;
  staffImageClashed;
  activeTab: string = "categories";
  classWiseAttendanceActiveTab: string = "day";
  strings: any = classStrings;
  searchValue: string = '';
  isSearchActive: boolean = false;
  loader: boolean = false;
  classAttendanceDetails: any = [];
  registrationStrings: any = registrationStrings;
  individualAttendanceLoader: boolean = false;
  globalAttendanceLoader: boolean = false;
  localSearchClassDetails: boolean = false;
  filterClassDetails: any = [];
  searchDebounceValue: any;
  globalAttendanceConfigurationStatusData: any;
  attendanceType: string;
  showGlobalAttendanceConfirmModal: boolean = false;
  brand = this.brandService.brand;
  constructor(private router: Router, private loginservice: LoginService, private classManageService: ClassManageService,
    private groupService: GroupService, private formValidator: FormValidator, private offcanvas: Offcanvas,
    private scriptLoader: ScriptLoader, private translate: TranslateService, private renderer: Renderer2,
    private el: ElementRef, private brandService: BrandService) {
  }

  classManagementGetClassCategory() {
    this.getCategoryListArray = [];
    this.destroyDataTable('categoryview-detail-table');
    this.classManageService.schoolClassManagementGetCategoryList(this.getSchoolId, this.academicId, this.getAuthToken)
      .subscribe(
        (data: any) => {
          for (var i = 0; i < data.classcategory.length; i++) {
            this.getCategoryListArray.push(data.classcategory[i]);
            if (data.classcategory.length - 1 == i) {
              this.initializeDataTable('categoryview-detail-table');
            }
          }
          this.getClassList();
        },
        error =>
          () => {
          }
      );
  }

  //get class category list
  getClassCategoryList() {
    this.classManageService.listClassCategory(localStorage.getItem('schoolinfo'), localStorage.getItem('usertoken'))
      .subscribe(
        (data: any) => {
          this.destroyDataTable('class-category-table');
          if (data.classcategory.length >= 0) {
            for (var i = 0; i < data.classcategory.length; i++) {
              this.classCategory.push(data.classcategory[i]);
              if (data.classcategory.length - 1 == i) {
                this.initializeDataTable('class-category-table');
              }
            }
          }
        },
        error =>
          () => {
          }
      );
  }

  getClassCategoryDetailList() {
    this.classManageService.listClassCategoryDetailList(localStorage.getItem('schoolinfo'), this.viewClassCategoryId, localStorage.getItem('usertoken'))
      .subscribe(
        (data: any) => {
          this.destroyDataTable('categoryviewdetail');
          if (data.classlist.length >= 0) {
            for (var i = 0; i < data.classlist.length; i++) {
              this.classCategoryDetailList.push(data.classlist[i]);
              if (data.classlist.length - 1 == i) {
                this.initializeDataTable('categoryviewdetail');
              }
            }
          }
        },
        error =>
          () => {
          }
      );
  }

  clearAddCatData() {
    this.addNewCategoryCategoryName = '';
    this.selectedStaff = null;
    this.isStaffHasPermissionToViewStudentFees = true;
  }

  clearAddSubData() {

  }

  clearAddClassData() {
    this.newStandardName = '';
    this.newStandardSections = [];
    this.selectedCatIdAddSection = 0;
    $('#addNewSection').val('');
  }


  //add new category
  addNewCategory() {
    this.classManageService.addNewCategoryService(localStorage.getItem('schoolinfo'), this.newCategoryName, localStorage.getItem('usertoken'))
      .subscribe(
        async (data: any) => {
          if (data.addNewCategory == false) {
            const errorPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('errorPleaseTryAgain')); 
            customToastr(errorPleaseTryAgainTranslation, 'error');
          } else {
            const newCategoryAddedTranslation = await firstValueFrom(this.translate.get('newCategoryAdded')); 
            customToastr(newCategoryAddedTranslation, 'success');
          }
        },
        error =>
          () => {
          }
      );
  }

  viewClassCategory(getid, totalclasses, totalsection, totalStudents, categoryname) {
    this.viewClassCategoryId = getid;
    this.viewClassCategorytotalclasses = totalclasses;
    this.viewClassCategorytotalsection = totalsection;
    this.viewClassCategorytotalStudents = totalStudents;
    this.viewClassCategoryName = categoryname;
    this.getClassCategoryDetailList();
  }

  //get class standard list
  getClassStandardList() {
    this.classManageService.listClassSection(localStorage.getItem('schoolinfo'), localStorage.getItem('usertoken'))
      .subscribe(
        (data: any) => {
          this.destroyDataTable('class-standard-table');
          if (data.schoolStandards.length >= 0) {
            for (var i = 0; i < data.schoolStandards.length; i++) {
              this.classStandards.push(data.schoolStandards[i]);
              if (data.schoolStandards.length - 1 == i) {
                this.initializeDataTable('class-standard-table');
              }
            }
          }
        },
        error =>
          () => {
          }
      );
  }

  //get all class category
  getClassCategories() {
    this.groupService.groupsClassCategories(localStorage.getItem('schoolinfo'), localStorage.getItem('usertoken'))
      .subscribe(
        (data: any) => {
          if (data.schoolCategory && data.schoolCategory.length > 0) {
            this.schoolCategories = JSON.parse(JSON.stringify(data.schoolCategory));
          }
          else {
            this.schoolCategories = [];
          }
          $('.insertsection div.bootstrap-tagsinput:not(:first)').remove();
        },
        error =>
          () => {

          }
      );
  }

  sectionDetails() {
    this.classManageService.sectionDetail(this.getSectiondIdClass, localStorage.getItem('usertoken'))
      .subscribe(
        (data: any) => {
          this.sectionDetail = data[0];
        },
        error =>
          () => {

          }
      );
  }

  //selected category for section add
  selectcategoryAddSection(selectedCatId) {
    this.selectedCatIdAddSection = selectedCatId;
  }

  selectSectionViewStandards(selectedSection) {
    this.selectedSectionIdViewStandards = selectedSection;
  }

  selectStatusStandards(selectedStatus) {
    this.selectedStatuaViewStandards = selectedStatus;
  }


  //add new section
  addNewSection() {
    $('.insertsection div.bootstrap-tagsinput:not(:first)').remove();
  }

  async addNewSection2(newStandardSections) {
    if (this.formValidator.validateIsData(newStandardSections)) {
      this.translate.get('pleaseWait').subscribe((translatedText: string) => { $('#stdName').text(translatedText); });
      $('#stdName').attr('disabled', true);
      this.newStandardSections = newStandardSections.split(',');
      const validateMessage = this.formValidator.validateFieldName(this.newStandardName, "Standard ")
      const validStandardSections = this.formValidator.validateFieldName(this.newStandardSections, "Section ")
      if (validateMessage) {
        this.translate.get('add').subscribe((translatedText: string) => { $('#stdName').text(translatedText); });
        $('#stdName').attr('disabled', false);
        customToastr(validateMessage, 'error');
      } else if (validStandardSections) {
        this.translate.get('add').subscribe((translatedText: string) => { $('#stdName').text(translatedText); });
        $('#stdName').attr('disabled', false);
        customToastr(validStandardSections, 'error');
      } else if (this.newStandardSections.length > 0 && this.formValidator.validateIsData(this.newStandardName) && this.selectedCatIdAddSection != 0 && this.selectedCatIdAddSection != null && this.selectedCatIdAddSection != undefined && !validStandardSections && !validateMessage) {
        for (var i = 0; i < this.newStandardSections.length; i++) {
          this.classManageService.addNewClassSections(localStorage.getItem('schoolinfo'), this.newStandardName, this.newStandardSections[i], this.selectedCatIdAddSection, localStorage.getItem('usertoken'),)
            .subscribe(
              async (data: any) => {
                if (data.status == true) {
                  this.translate.get('add').subscribe((translatedText: string) => { $('#stdName').text(translatedText); });
                  $('#stdName').attr('disabled', false);
                  const newStandardAddedTranslation = await firstValueFrom(this.translate.get('newStandardAdded')); 
                  customToastr(newStandardAddedTranslation, 'success');
                  $('#addstandards').trigger('click');
                  //this.getClassList();
                } else if (data.status == false) {
                  this.translate.get('add').subscribe((translatedText: string) => { $('#stdName').text(translatedText); });
                  $('#stdName').attr('disabled', false);
                  const classAndSectionAreAlreadyExistPleaseEnterDifferentNameTranslation = await firstValueFrom(this.translate.get('classAndSectionAreAlreadyExistPleaseEnterDifferentName')); 
                  customToastr(classAndSectionAreAlreadyExistPleaseEnterDifferentNameTranslation, 'error');
                } else if (data.errorcode == 10037) {
                  this.translate.get('add').subscribe((translatedText: string) => { $('#stdName').text(translatedText); });
                  $('#stdName').attr('disabled', false);
                  const only5ClassesAreAllowedToAddInTrailSubscriptionTranslation = await firstValueFrom(this.translate.get('only5ClassesAreAllowedToAddInTrailSubscription')); 
                  customToastr(only5ClassesAreAllowedToAddInTrailSubscriptionTranslation, 'error');
                } else {
                  this.translate.get('add').subscribe((translatedText: string) => { $('#stdName').text(translatedText); });
                  $('#stdName').attr('disabled', false);
                  const errorPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('errorPleaseTryAgain')); 
                  customToastr(errorPleaseTryAgainTranslation, 'error');
                }
              },
              error =>
                () => {
                }
            );

        }
        setTimeout(() => {
          this.getClassList();
        }, 1000)
      } else {
        this.translate.get('add').subscribe((translatedText: string) => { $('#stdName').text(translatedText); });
        $('#stdName').attr('disabled', false);
        const pleaseFillAllFieldsTranslation = await firstValueFrom(this.translate.get('pleaseFillAllFields')); 
        customToastr(pleaseFillAllFieldsTranslation, 'error');
      }
    } else {
      const pleaseFillAllFieldsTranslation = await firstValueFrom(this.translate.get('pleaseFillAllFields')); 
      customToastr(pleaseFillAllFieldsTranslation, 'error');
    }
  }

  addNewSectionInDetail() {
    $('#add-section-new').popover('show');
    $('.close-add-section').click(function () {
      $('#add-section-new').popover('hide');
    });
  }

  //delete section from standard
  deleteSectionInStdView() {
    this.classManageService.deleteSectionInStdView(this.getSectiondIdClass, localStorage.getItem('usertoken'),)
      .subscribe(
        async (data: any) => {
          if (data.status == false) {
            const errorPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('errorPleaseTryAgain')); 
            customToastr(errorPleaseTryAgainTranslation, 'error');
          } else {
            const deleteSectionSuccessTranslation = await firstValueFrom(this.translate.get('deleteSectionSuccess')); 
            customToastr(deleteSectionSuccessTranslation, 'success');
            $('#deletepopupclose').trigger('click');
            this.getStandardViewSectionList();
            this.getSectionListClassView(this.getClassStandardIdList);
            this.getClassList();
            this.getCategoryClassListtotalSections = this.getCategoryClassListtotalSections - 1;
          }
        },
        error =>
          () => {
          }
      );

  }

  //Update section from standard

  async UpdateSectionInStdView(getSectionNameInClass) {
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $('#updateSec').text(translatedText); });
    $('#updateSec').attr('disabled', true);
    var catId = $('#cat').val();
    const validateSectionName = this.formValidator.validateFieldName(getSectionNameInClass, "Section ")
    if (this.formValidator.validateIsData(getSectionNameInClass) && catId && this.formValidator.validateIsData(catId) && !validateSectionName) {
      this.classManageService.UpdateSectionInStdView(this.classStdId, this.getSectiondIdClass, getSectionNameInClass, catId, localStorage.getItem('usertoken'),)
        .subscribe(
          async (data: any) => {
            this.translate.get('update').subscribe((translatedText: string) => { $('#updateSec').text(translatedText); });
            $('#updateSec').attr('disabled', false);
            if (data.status == true) {
              const sectionUpdatedSuccessfullyTranslation = await firstValueFrom(this.translate.get('sectionUpdatedSuccessfully')); 
              customToastr(sectionUpdatedSuccessfullyTranslation, 'success');
              $('#closeupdatesection').trigger('click');
              this.getSectionListClassView(this.getClassStandardIdList);
              this.getStandardViewSectionList();
            } else if (data.status == false) {
              const sectionNameIsAlreadyExistPleaseTryDifferentNameTranslation = await firstValueFrom(this.translate.get('sectionNameIsAlreadyExistPleaseTryDifferentName')); 
              customToastr(sectionNameIsAlreadyExistPleaseTryDifferentNameTranslation, 'error');
            } else {
              const sectionIsNotUpdatedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('sectionIsNotUpdatedPleaseTryAgain')); 
              customToastr(sectionIsNotUpdatedPleaseTryAgainTranslation, 'error');
            }
          },
          error =>
            () => {
            }
        );
    } else if (validateSectionName) {
      this.translate.get('update').subscribe((translatedText: string) => { $('#updateSec').text(translatedText); });
      $('#updateSec').attr('disabled', false);
      customToastr(validateSectionName, 'error');
    } else {
      this.translate.get('update').subscribe((translatedText: string) => { $('#updateSec').text(translatedText); });
      $('#updateSec').attr('disabled', false);
      const pleaseFillAllFieldsTranslation = await firstValueFrom(this.translate.get('pleaseFillAllFields')); 
      customToastr(pleaseFillAllFieldsTranslation, 'error');
    }

  }


  //class standatrds detailed view///////////
  viewClassStandards(className, totalSections, categoryName, totalStudents, totalStaffs, standardId, categoryId) {
    this.viewStandardName = className;
    this.viewStandardId = standardId;
    this.viewStandardIdInClass = standardId;
    this.viewStandardcategoryName = categoryName;
    this.viewStandardcategoryId = categoryId;
    this.viewStandardtotalSections = totalSections.replace('Sections', '');
    this.viewStandardtotalStudents = totalStudents.replace('Students', '');
    this.viewStandardtotalStaffs = totalStaffs.replace('Staffs', '');
    this.getStandardViewSectionList();

  }

  //get list of section in standard view
  getStandardViewSectionList() {

    this.classManageService.viewStandardListSection(this.getClassStdId, localStorage.getItem('usertoken'),)
      .subscribe(
        (data: any) => {
          if (data.length > 0) {
            this.viewStandardSections = JSON.parse(JSON.stringify(data));
          }
          else {
            this.viewStandardSections = [];
          }
        },
        error =>
          () => {
          }
      );
  }

  /*Sample datatable /////////////////////////////////////////////*/
  initDataTable(academicId, categoryId, classId, sectionId, studenttableName) {
    this.translate.get([
      'dataTables.processing',
      'dataTables.search',
      'dataTables.processing',
      'dataTables.lengthMenu',
      'dataTables.info',
      'dataTables.infoEmpty',
      'dataTables.infoFiltered',
      'dataTables.paginate.first',
      'dataTables.paginate.last',
      'dataTables.paginate.next',
      'dataTables.paginate.previous',
      'dataTables.buttons.copy',
      'dataTables.buttons.excel',
      'dataTables.buttons.csv',
      'dataTables.buttons.colvis',
      'dataTables.buttons.colvisRestore',
      'dataTables.exportTitle',
    ]).subscribe(translations => {
    $('#' + studenttableName).DataTable({
      destroy: true,
      language: {
        search: translations['dataTables.search'],
        lengthMenu: translations['dataTables.lengthMenu'],
        info: translations['dataTables.info'],
        infoEmpty: translations['dataTables.infoEmpty'],
        infoFiltered: translations['dataTables.infoFiltered'],
        paginate: {
          first: translations['dataTables.paginate.first'],
          last: translations['dataTables.paginate.last'],
          next: translations['dataTables.paginate.next'],
          previous: translations['dataTables.paginate.previous']
        },
        processing:
          `<h3 style='color: var(--brand-primary-color);font-size: 2em;font-weight: 100;'>${translations['dataTables.processing']}</h3>`,
      },
      'processing': true,
      'serverSide': true,
      'ajax': {
        beforeSend: function (request) {
          request.setRequestHeader('Content-Type', 'application/json');
          request.setRequestHeader('authToken', localStorage.getItem('usertoken'));
        },

        url: AppSettings.API_ENDPOINT + '/studentlist',
        type: 'POST',
        'data': function (d) {
          return JSON.stringify({
            'schoolId': localStorage.getItem('schoolinfo'),
            'academicId': academicId,
            'categoryId': categoryId,
            'classId': classId,
            'sectionId': sectionId,
            'countFrom': d.start,
            'lengthOf': d.length
          });
        }
      },
      'columns': [
        { 'data': 'rollNumber' },
        { 'data': 'studentName' },
        { 'data': 'parentName' },
        { 'data': 'mobileNumber' },
        { 'data': 'dateOfBirth' },
        { 'data': 'gender' },
        { 'data': 'isAppUser' }
      ]
    });
  });
  }

  //get current academic id
  getAcademicList() {
    this.groupService.groupsStudentAcademicList(localStorage.getItem('schoolinfo'), localStorage.getItem('usertoken'))
      .subscribe(
        (data: any) => {
          for (var i = 0; i < data.academicList.length; i++) {
            if (data.academicList[i].InActive == 0) {
              this.academicId = data.academicList[i].pkAcademicId;
            }
          }
        },
        error =>
          () => {

          }
      );
  }

  getCategoryList() {
    this.destroyDataTable('categoryview-detail-table');
    this.classManageService.getCategoryListService(this.getSchoolId, this.getAuthToken)
      .subscribe(
        (data: any) => {
          if (data.cateogorylist && data.cateogorylist.length > 0) {
            this.getCategoryListArray = JSON.parse(JSON.stringify(data.cateogorylist));
          }
          else {
            this.getCategoryListArray = [];
          }
          this.initializeDataTable('categoryview-detail-table');
        },
        error =>
          () => {
          }
      );
  }

  classDetailView(catname, ttclasses, ttsections, ttstudents, catid) {
    this.offcanvas.handleOffcanvasOpen('#offcanvas-view-class-categories');
    this.getViewCatName = catname;
    this.getViewttclasses = ttclasses;
    this.getViewttsections = ttsections;
    this.getViewttstudents = ttstudents;
    this.getViewcatid = catid;
    this.getCategoryClassList();
  }

  getCategoryClassList() {
    this.getCategoryClassListArray = [];
    this.destroyDataTable('category-detail-view-table');
    this.classManageService.getCategoryClassListService(this.getSchoolId, this.academicId, this.getViewcatid.CategoryId, this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.classlistbycat = data;
          setTimeout(() => {
            this.translate.get([
              'dataTables.emptyTable',
              'dataTables.search',
              'dataTables.lengthMenu',
              'dataTables.info',
              'dataTables.infoEmpty',
              'dataTables.paginate.next',
              'dataTables.paginate.previous',
            ]).subscribe(translations => {
              $('#category-detail-view-table').DataTable({
                language: {
                  emptyTable: translations['dataTables.emptyTable'],
                  search: translations['dataTables.search'],
                  lengthMenu: translations['dataTables.lengthMenu'],
                  info: translations['dataTables.info'],
                  infoEmpty: translations['dataTables.infoEmpty'],
                  paginate: {
                    next: translations['dataTables.paginate.next'],
                    previous: translations['dataTables.paginate.previous']
                  }
                },
              });
            });
          }, 100);
          if (this.classlistbycat.length == 0) {
            $('#dataCategory').show();
            $('#tablebycategorylist').hide();
          } else {
            $('#dataCategory').hide();
            $('#tablebycategorylist').show();
          }
        },
        error =>
          () => {
          }
      );
  }

  categoryClassDetailView(className, totalSections, totalStudents, classId) {
    this.classStandardName = className;
    this.getCategoryClassListtotalSections = totalSections;
    this.getCategoryClassListtotalStudents = totalStudents;
    this.getCategoryClassListclassId = classId;

  }

  offcanvasviewclass(categoryclass, classId) {
    this.offcanvas.handleOffcanvasOpen('#offcanvas-view-class');
    this.getCategoryClassListclassIdView = categoryclass.classId;
    this.getSectionListClassView(classId);
    this.getClassSectionStudentListArray = [];
  }

  addNewCategoryCategoryList() {
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $('#addNewCat').text(translatedText); });
    $('#addNewCat').attr('disabled', true);
    const validateMessage = this.formValidator.validateFieldName(this.addNewCategoryCategoryName, "Category ")
    if (validateMessage) {
      this.translate.get('add').subscribe((translatedText: string) => { $('#addNewCat').text(translatedText); });
      $('#addNewCat').attr('disabled', false);
      customToastr(validateMessage, 'error');
    } else {
      this.classManageService.addCategoryNewCategoryService(this.addNewCategoryCategoryName, this.getSchoolId, this.getAuthToken)
        .subscribe(
          async (data: any) => {
            if (data.status == true) {
              this.translate.get('add').subscribe((translatedText: string) => { $('#addNewCat').text(translatedText); });
              $('#addNewCat').attr('disabled', false);
              const newCategoryAddedTranslation = await firstValueFrom(this.translate.get('newCategoryAdded')); 
              customToastr(newCategoryAddedTranslation, 'success');
              this.addNewCategoryCategoryName = '';
              $('#addNewCategoryCategoryName').val('');
              $('#addcategory').trigger('click');
              this.getCategoryList();
            } else if (data.status == false) {
              this.translate.get('add').subscribe((translatedText: string) => { $('#addNewCat').text(translatedText); });
              $('#addNewCat').attr('disabled', false);
              const categoryNameIsAlreadyExistPleaseEnterDifferentNameTranslation = await firstValueFrom(this.translate.get('categoryNameIsAlreadyExistPleaseEnterDifferentName')); 
              customToastr(categoryNameIsAlreadyExistPleaseEnterDifferentNameTranslation, 'error');
            } else {
              const categoryIsNotAddedTranslation = await firstValueFrom(this.translate.get('categoryIsNotAdded')); 
              customToastr(categoryIsNotAddedTranslation, 'error');
            }
          },
          error =>
            () => {
            }
        );
    }
  }

  async updateCategoryCategoryName() {
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $('#upCatName').text(translatedText); });
    $('#upCatName').attr('disabled', true);
    if (!this.formValidator.validateIsData(this.editCategoryCategoryName)) {
      this.translate.get('update').subscribe((translatedText: string) => { $('#upCatName').text(translatedText); });
      $('#upCatName').attr('disabled', false);
      const pleaseDoSomeChangesTranslation = await firstValueFrom(this.translate.get('pleaseDoSomeChanges')); 
      customToastr(pleaseDoSomeChangesTranslation, 'error');
    } else {
      this.classManageService.updateCategoryListCategoryService(this.editCategoryCategoryName, this.getSchoolId, this.getViewcatid.CategoryId, this.getAuthToken)
        .subscribe(
          async (data: any) => {
            if (data.categoryUpdateStatus == true) {
              this.translate.get('update').subscribe((translatedText: string) => { $('#upCatName').text(translatedText); });
              $('#upCatName').attr('disabled', false);
              this.getViewCatName = this.editCategoryCategoryName;
              const categoryNameUpdatedTranslation = await firstValueFrom(this.translate.get('categoryNameUpdated')); 
              customToastr(categoryNameUpdatedTranslation, 'success');
              $('#closeUpdateCatPopup').trigger('click');
              this.getCategoryList();
            } else if (data.status == false) {
              this.translate.get('update').subscribe((translatedText: string) => { $('#upCatName').text(translatedText); });
              $('#upCatName').attr('disabled', false);
              const givenCategoryNameIsAlreadyExistPleaseGiveDifferentNameTranslation = await firstValueFrom(this.translate.get('givenCategoryNameIsAlreadyExistPleaseGiveDifferentName')); 
              customToastr(givenCategoryNameIsAlreadyExistPleaseGiveDifferentNameTranslation, 'error');
            } else {
              this.translate.get('update').subscribe((translatedText: string) => { $('#upCatName').text(translatedText); });
              $('#upCatName').attr('disabled', false);
              const categoryNameIsNotUpdatedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('categoryNameIsNotUpdatedPleaseTryAgain')); 
              customToastr(categoryNameIsNotUpdatedPleaseTryAgainTranslation, 'error');
            }
          },
          error =>
            () => {
            }
        );
    }
  }

  updateClassName(updateClassStdName) {
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $('#classButton').text(translatedText); });
    $('#classButton').attr('disabled', true);
    this.updateClassStdName.className = $('.stdName').val();
    const validateClassName = this.formValidator.validateFieldName(this.updateClassStdName.className, "Class")
    if (!validateClassName) {
      this.classManageService.updateClassNameService(this.classStdId, this.updateClassStdName.className, this.getAuthToken)
        .subscribe(
          async (data: any) => {
            this.translate.get('update').subscribe((translatedText: string) => { $('#classButton').text(translatedText); });
            $('#classButton').attr('disabled', false);
            if (data.classNameUpdateStatus == true) {
              this.classStandardName = this.updateClassStdName.className;
              const classNameUpdatedTranslation = await firstValueFrom(this.translate.get('classNameUpdated')); 
              customToastr(classNameUpdatedTranslation, 'success');
              $('#closeUpdateClass').trigger('click');
              this.getClassList();
              this.getSectionListClassView(this.classStdId);
            } else if (data.status == false) {
              const givenClassNameIsAlreadyExistPleaseGiveDifferentNameTranslation = await firstValueFrom(this.translate.get('givenClassNameIsAlreadyExistPleaseGiveDifferentName')); 
              customToastr(givenClassNameIsAlreadyExistPleaseGiveDifferentNameTranslation, 'error');
            } else {
              const classNameIsNotUpdatedTranslation = await firstValueFrom(this.translate.get('classNameIsNotUpdated')); 
              customToastr(classNameIsNotUpdatedTranslation, 'error');
            }
          },
          error =>
            () => {
            }
        );
    } else {
      this.translate.get('update').subscribe((translatedText: string) => { $('#classButton').text(translatedText); });
      $('#classButton').attr('disabled', false);
      customToastr(validateClassName, 'error');
    }
  }

  //add new class modal click
  addNewClassModal() {
    this.clearAddClassData();
    $('.insertsection div.bootstrap-tagsinput:not(:first)').remove();
    this.getClassCategories();
  }

  getClassList() {
    this.getClassListArray = [];
    this.destroyDataTable('classview-detail-table');
    this.groupService.groupsStudentAcademicList(this.getSchoolId, this.getAuthToken)
      .subscribe(
        (data: any) => {
          for (var i = 0; i < data.academicList.length; i++) {
            if (data.academicList[i].InActive == 0) {
              this.academicId = data.academicList[i].pkAcademicId;
              //call class list
              this.classManageService.schoolClassManagementGetClassList(this.getSchoolId, this.academicId, this.getAuthToken)
                .subscribe(
                  (data: any) => {
                    this.getClassListArray = JSON.parse(JSON.stringify(data.classlist));
                    this.initializeDataTable('classview-detail-table');
                    this.listAllSubjects();
                  },
                  error =>
                    () => {
                    }
                );
            }
          }
        },
        error =>
          () => {
          }
      );
  }

  getclassDetailView(className, totalSections, categoryName, classId, totalStudents, totalStaffs, catId, classStdId) {
    $('#updateSectionSequence').hide();
    $('#classTeacherList').hide();
    $('#class-detail-student-detail-tab').hide();

    $('#subject-table').hide();
    $('#section-List').show();

    this.offcanvas.handleOffcanvasOpen('#offcanvas-view-class');
    this.classStandardName = className;
    this.getViewCatName = categoryName;
    this.getClassListCatId = catId;
    this.viewClassCategorytotalStudents = totalStudents;
    this.viewStandardtotalStaffs = totalStaffs;
    this.getCategoryClassListtotalSections = totalSections;
    this.getCategoryClassListclassId = classId;
    this.classStdId = classStdId;
    this.getSectionListClassView(this.getCategoryClassListclassId);
  }

  //get section list with classtandard id
  getSectionListClassView(classStandardId) {
    this.destroyDataTable('view-class-detail-student-table');
    this.getClassStandardIdList = classStandardId;

    this.classManageService.getClassSectionListService(this.getSchoolId, this.getClassStandardIdList, this.getAuthToken)
      .subscribe(
        (data: any) => {
          if (data.length > 0) {
            this.getClassViewClassSectionArray = JSON.parse(JSON.stringify(data));
          }
          else {
            this.getClassViewClassSectionArray = [];
          }
        },
        error => {
        }
      );
  }

  selectcategoryViewClassSection(event) {
    this.destroyDataTable('view-class-detail-student-table');
    this.getSeletedSectionClassIdView = $('#selectedsection').val();
    this.getSeletedSectionSectionId = event.target.value;
  }

  classViewAddNewSection() {
    this.addNewSectionStatus = true;
    this.getNewSectionName = '';
  }

  classViewAddNewSectionCancel() {
    this.addNewSectionStatus = false;
  }

  async classViewAddNewSectionProcess() {
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $('#addSectionButton').text(translatedText); });
    $('#addSectionButton').attr('disabled', true);
    if (!this.formValidator.validateIsData(this.getNewSectionName)) {
      this.translate.get('addSection').subscribe((translatedText: string) => { $('#addSectionButton').text(translatedText); });
      $('#addSectionButton').attr('disabled', false);
      const pleaseEnterAValidSectionNameTranslation = await firstValueFrom(this.translate.get('pleaseEnterAValidSectionName')); 
      customToastr(pleaseEnterAValidSectionNameTranslation, 'error');
    } else {
      this.classManageService.getClassViewaddNewClassSections(this.getSchoolId, this.classStandardName, this.getNewSectionName, this.getClassListCatId, this.getAuthToken)
        .subscribe(
          async (data: any) => {
            if (data.status == true) {
              this.translate.get('addSection').subscribe((translatedText: string) => { $('#addSectionButton').text(translatedText); });
              $('#addSectionButton').attr('disabled', false);
              this.addNewSectionStatus = false;
              const newSectionAddedToTheClassSuccessfullyTranslation = await firstValueFrom(this.translate.get('newSectionAddedToTheClassSuccessfully')); 
              customToastr(newSectionAddedToTheClassSuccessfullyTranslation, 'success');
              this.getNewSectionName;
              this.getSectionListClassView(this.getClassStandardIdList);
              this.getClassList();
              this.getCategoryClassListtotalSections = this.getCategoryClassListtotalSections + 1;
            } else if (data.status == false) {
              this.translate.get('addSection').subscribe((translatedText: string) => { $('#addSectionButton').text(translatedText); });
              $('#addSectionButton').attr('disabled', false);
              const classSectionAlreadyExistPleaseUseDifferentNameTranslation = await firstValueFrom(this.translate.get('classSectionAlreadyExistPleaseUseDifferentName')); 
              customToastr(classSectionAlreadyExistPleaseUseDifferentNameTranslation, 'error');
            } else {
              this.translate.get('addSection').subscribe((translatedText: string) => { $('#addSectionButton').text(translatedText); });
              $('#addSectionButton').attr('disabled', false);
              const somethingWentWrongPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('somethingWentWrongPleaseTryAgain')); 
              customToastr(somethingWentWrongPleaseTryAgainTranslation, 'error');
            }
          },
          error =>
            () => {
            }
        );
    }
  }

  //deletesection and edit
  editSectionPopup() {
    this.sectionDetails();
    $('#editSectionModal-opener').trigger('click');
  }

  deleteSectionPopup() {
    $('#deletesectionmodal-opener').trigger('click');
  }

  classViewSectionName(sectionName, sectionId, classStdId) {
    this.getSectionNameInClass = sectionName;
    this.getSectiondIdClass = sectionId;
    this.getClassStdId = classStdId;
  }

  /*Subject start////////////////////////////*/
  async viewSubject() {
    $('#subject-Status').show();
    $('#subject-table').hide();
    var selectSection = $('#selectSectionId').val();
    this.sectionId = selectSection;
    if (selectSection != '') {
      if (selectSection != 0) {
        this.getSubjectListByClass(selectSection);
      } else {
        $('#subject-Status').hide();
        const pleaseSelectSectionTranslation = await firstValueFrom(this.translate.get('pleaseSelectSection')); 
        customToastr(pleaseSelectSectionTranslation, 'error');
      }
    }
  }

  listAllSubjects() {
    this.destroyDataTable('subject-List-table');

    this.classManageService.schoolClassManagementGetSubjectList(this.getSchoolId, this.getAuthToken)
      .subscribe(
        (data: any) => {
          if (data.subjectlist && data.subjectlist.length > 0) {
            this.getSubjectListArray = JSON.parse(JSON.stringify(data.subjectlist));
          }
          else {
            this.getSubjectListArray = [];
          }
          this.initializeDataTable('subject-List-table');
        },
        error =>
          () => {
          }
      );
  }

  getSubjectListByClass(classId) {
    if (classId == 0) {
      return;
    }
    this.subjectList = [];
    this.selectedClassId = classId;
    this.classManageService.fetchSubjectListandStaff(this.selectedClassId, localStorage.getItem('usertoken'))
      .subscribe(
        (data: any) => {
          if (data.errorcode) {

          } else {
            $('#subject-Status').hide();
            $('#subject-table').show();
            this.subjectList = data;
          }
        },
        error =>
          () => {
          }
      );
  }

  getsubjectDetailView(subjectName, subjectId, subjectBelonging) {
    this.offcanvas.handleOffcanvasOpen('#offcanvas-view-classsubjects');
    this.getViewsubjectName = subjectName;
    this.getViewsubjectCategoryName = null;
    this.getViewsubjectBelonging = subjectBelonging;
    this.getSubjectId = subjectId;
    this.getSubjectListViewArray = [];
    this.classManageService.schoolClassManagementGetSubjectListView(subjectId, this.getAuthToken)
      .subscribe(
        (data: any) => {
          if (data.subjectlistview && data.subjectlistview.length > 0) {
            this.getSubjectListViewArray = JSON.parse(JSON.stringify(data.subjectlistview));
          }

          if (this.getSubjectListViewArray.length == 0) {
            $('#unavailSub').show();
          } else {
            $('#unavailSub').hide();
          }
        },
        error => {
        }
      );
  }

  assignsubjectinclass(sub, val, i) {
    sub.isLoading = true;
    if (val == true) {
      this.classManageService.assignSubjectToClass(this.sectionId, sub.subjectId, localStorage.getItem('usertoken'))
        .subscribe(
          async(data: any) => {
            sub.isLoading = false;
            if (data.status == true) {
              //this.subjectListNotInClass.splice(i,1);
              const subjectSuccessfullyAssignedToClassTranslation = await firstValueFrom(this.translate.get('subjectSuccessfullyAssignedToClass')); 
              customToastr(subjectSuccessfullyAssignedToClassTranslation, 'success');
            } else {
              sub.inClass = false;
              const subjectIsNotAssignedToClassPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('subjectIsNotAssignedToClassPleaseTryAgain')); 
              customToastr(subjectIsNotAssignedToClassPleaseTryAgainTranslation, 'error');
            }
          },
          async error => {
            sub.inClass = false;
            sub.isLoading = false;
            const subjectIsNotAssignedToClassPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('subjectIsNotAssignedToClassPleaseTryAgain')); 
            customToastr(subjectIsNotAssignedToClassPleaseTryAgainTranslation, 'error');
          }
        );
    } else {

      this.classManageService.removeSubjectfromClass(this.sectionId, sub.subjectId, localStorage.getItem('usertoken'))
        .subscribe(
          async (data: any) => {
            if (data.status == true) {
              this.subjectList.splice(i, 1);
              const subjectSuccessfullyRemovedFromTheClassTranslation = await firstValueFrom(this.translate.get('subjectSuccessfullyRemovedFromTheClass')); 
              customToastr(subjectSuccessfullyRemovedFromTheClassTranslation, 'success');
            } else {
              sub.isLoading = false;
              const subjectNotRemovedFromTheClassPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('subjectNotRemovedFromTheClassPleaseTryAgain')); 
              customToastr(subjectNotRemovedFromTheClassPleaseTryAgainTranslation, 'error');
            }
          },
          async error => {
            sub.isLoading = false;
            const subjectNotRemovedFromTheClassPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('subjectNotRemovedFromTheClassPleaseTryAgain')); 
            customToastr(subjectNotRemovedFromTheClassPleaseTryAgainTranslation, 'error');
          }
        );
    }
  }

  searchstaffForsubject(searchStaff) {
    this.classManageService.searchStaff(searchStaff.searchData, localStorage.getItem('usertoken'))
      .subscribe(
        (data: any) => {
          if (data.errorcode) {

          } else {
            searchStaff.stafList = data;
            if (data > 0) {
              $('#search-staff_' + searchStaff.subjectId).show();
            } else {
              $('#search-staff_' + searchStaff.subjectId).hide();
            }
          }
        },
        error =>
          () => {
          }
      );
  }

  assignSubjectToStaff(staff, sub) {
    sub.stafList = [];
    $('#search-staff_' + sub.stafList).hide();
    var classId = this.sectionId;
    this.classManageService.assignSubjectTostaff(staff.staffId, classId, sub.subjectId, localStorage.getItem('usertoken'))
      .subscribe(
        async (data: any) => {
          if (data.status == true) {
            const subjectAssignToStaffSuccessfullyTranslation = await firstValueFrom(this.translate.get('subjectAssignToStaffSuccessfully')); 
            customToastr(subjectAssignToStaffSuccessfullyTranslation, 'success');
            this.getSubjectListByClass(classId);
          } else {
            const subjectIsNotAssignToStaffPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('subjectIsNotAssignToStaffPleaseTryAgain')); 
            customToastr(subjectIsNotAssignToStaffPleaseTryAgainTranslation, 'error');
          }
        },
        error =>
          () => {
          }
      );
  }

  unAssignStaffFromSubject(staf) {
    var classId = this.sectionId;
    this.classManageService.unAssignSubjectTostaff(classId, staf.staffId, staf.subjectId, localStorage.getItem('usertoken'))
      .subscribe(
        async (data: any) => {
          if (data.status == true) {
            const staffSuccessfullyUnassignedFromSubjectTranslation = await firstValueFrom(this.translate.get('staffSuccessfullyUnassignedFromSubject')); 
            customToastr(staffSuccessfullyUnassignedFromSubjectTranslation, 'success');
            this.getSubjectListByClass(classId);
          } else {
            const staffNotUnassignedFromSubjectPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('staffNotUnassignedFromSubjectPleaseTryAgain')); 
            customToastr(staffNotUnassignedFromSubjectPleaseTryAgainTranslation, 'error');
          }
        },
        error =>
          () => {
          }
      );
  }

  async addNewSubject(addSub) {
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $('#addSubButton').text(translatedText); });
    $('#addSubButton').attr('disabled', true);
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $('#addSub').text(translatedText); });
    $('#addSub').attr('disabled', true);
    var classId = this.sectionId;
    if (addSub.subjectname != null && addSub.subjectname != '' && addSub.subjectname != undefined) {
      this.classManageService.addSubject(addSub.subjectname, localStorage.getItem('usertoken'))
        .subscribe(
          async (data: any) => {
            this.translate.get('addSubject').subscribe((translatedText: string) => { $('#addSubButton').text(translatedText); });
            $('#addSubButton').attr('disabled', false);
            this.translate.get('addSubject').subscribe((translatedText: string) => { $('#addSub').text(translatedText); });
            $('#addSub').attr('disabled', false);
            if (data.status == true) {
              const subjectAddedSuccessfullyTranslation = await firstValueFrom(this.translate.get('subjectAddedSuccessfully')); 
              customToastr(subjectAddedSuccessfullyTranslation, 'success');
              $('#addNewSubject').hide();
              $('#addSubject').show();
              $('#add-new-subject').hide();
              $('#addSubjectNew').show();
              this.getSubjectListByClass(classId);
              this.listAllSubjects();
            } else if (data.status == false) {
              const subjectIsAlreadyExistPleaseTryDifferentNameTranslation = await firstValueFrom(this.translate.get('subjectIsAlreadyExistPleaseTryDifferentName')); 
              customToastr(subjectIsAlreadyExistPleaseTryDifferentNameTranslation, 'error');
            } else {
              const subjectIsNotAddedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('subjectIsNotAddedPleaseTryAgain')); 
              customToastr(subjectIsNotAddedPleaseTryAgainTranslation, 'error');
            }
          },
          error =>
            () => {
            }
        );
    } else {
      this.translate.get('addSubject').subscribe((translatedText: string) => { $('#addSubButton').text(translatedText); });
      $('#addSubButton').attr('disabled', false);
      this.translate.get('addSubject').subscribe((translatedText: string) => { $('#addSubButton').text(translatedText); });
      $('#addSub').attr('disabled', false);
      const pleaseGiveSubjectNameTranslation = await firstValueFrom(this.translate.get('pleaseGiveSubjectName')); 
      customToastr(pleaseGiveSubjectNameTranslation, 'error');
    }
  }

  async viewTeacher() {
    $('#classTeacherList').hide();
    this.staffsList = [];
    $('#addNewClassTeacher').hide();
    $('#noClassTeacher').hide();
    $('#classTeacher-Status').show();
    var selectSection = $('#selectSection').val();
    this.classSectionId = selectSection;
    if (selectSection != '') {
      if (selectSection != 0) {
        this.getClassTeacherListByClass(selectSection);
      } else {
        $('#classTeacher-Status').hide();
        const pleaseSelectSectionTranslation = await firstValueFrom(this.translate.get('pleaseSelectSection')); 
        customToastr(pleaseSelectSectionTranslation, 'error');
      }
    }

  }

  getClassTeacherListByClass(classId) {
    this.classManageService.fetchClassTeacher(this.classSectionId, localStorage.getItem('usertoken'))
      .subscribe(
        (data: any) => {
          if (data.length > 0) {
            $('#classTeacherList').show();
          }
          $('#classTeacher-Status').hide();
          this.teacherList = data.status == false ? [] : data;
          if (data.length == 6) {
            $('#addTeacher').hide();
          } else {
            $('#addTeacher').show();
          }
          if (data.status == false) {
            $('#noClassTeacher').show();
          } else {
            $('#noClassTeacher').hide();
          }
        },
        error => {

        }
      );
  }

  searchClassTeacher(searchTeacher) {
    this.staffsList = [];
    this.isProcessing = true;
    this.classManageService.searchClassTeacher(searchTeacher, localStorage.getItem('usertoken'))
      .subscribe(
        async (data: any) => {
          this.isProcessing = false;
          if (data && data.length > 0) {
            this.staffsList = data;
            $('#stdTeacherList').show();

          } else {
            const thereAreNoMatchingClassTeachersForYourSearchTranslation = await firstValueFrom(this.translate.get('thereAreNoMatchingClassTeachersForYourSearch')); 
            customToastr(thereAreNoMatchingClassTeachersForYourSearchTranslation, 'error');
            this.staffsList = [];
            $('#stdTeacherList').hide();
          }
        },
        async error => {
          const failedToSearhClassTeachersPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToSearhClassTeachersPleaseTryAgain')); 
          customToastr(failedToSearhClassTeachersPleaseTryAgainTranslation, 'error');
          this.staffsList = [];
          $('#stdTeacherList').hide();
          this.isProcessing = false;
        }
      );
  }

  selectStaff(staff: any) {
  this.selectedStaff = staff;
}

  async updateStaffPermissionForFeeAccess(staffs?, isEnabled?) {
  var classId = this.classSectionId;
  try {
       const body = {
        lang : "en",
        staffId: staffs,
        classId: classId,
        isStaffHasPermissionToViewStudentFees: isEnabled
       }
              const response: any = await firstValueFrom(this.classManageService.staffPermissionForFeeAccess(body))
              if (response?.status && response?.body?.message) {
              customToastr(response.body.message, 'success');
              }
          }
          catch (error) {
              const teacherIsNotAssignToThisClassPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('somethingWentWrong'));
               customToastr(teacherIsNotAssignToThisClassPleaseTryAgainTranslation, 'error');
          }

 }


  assignClassTeacher(staffs?, isEnabled?) {
    const staff = staffs || this.selectedStaff;
    const enabledStatus = isEnabled !== undefined ? isEnabled : this.isStaffHasPermissionToViewStudentFees;
  
    if (!staff) {
      return;
    }

    $('#noClassTeacher').hide();
    $('#stdTeacherList').hide();
    $('#addNewClassTeacher').hide();
    var position;
    if (this.teacherList.length == 0) {
      position = 0;
    } else if (this.teacherList.length == 1) {
      position = 1;
    } else if (this.teacherList.length == 2) {
      position = 2;
    } else  if (this.teacherList.length == 3){
      position = 3;
    } else if (this.teacherList.length == 4) {
      position = 4;
    } else {
      position = 5;
    }
    if (this.editClassTeacher) {
      position = this.editClassTeacher.position;
    }
    var classId = this.classSectionId;
    this.isProcessing = true;
      const tempStaffId = staff.staffId;
      const tempEnabled = enabledStatus;
  
  // Hide toggle immediately
  this.selectedStaff = null;

    this.classManageService.addClassTeacher(classId, staffs.staffId, position, localStorage.getItem('usertoken'), this.isStaffHasPermissionToViewStudentFees)
      .subscribe(
        async (data: any) => {
          this.isProcessing = false;
          if (data.status == true) {
            const teacherAssignToThisClassSuccessfullyTranslation = await firstValueFrom(this.translate.get('teacherAssignToThisClassSuccessfully')); 
            customToastr(teacherAssignToThisClassSuccessfullyTranslation, 'success');
            this.staffsList = [];
            $('#search-staff-assign').val('');
            $('#close-assign-class-teacher-popup').trigger('click');
            this.getClassTeacherListByClass(classId);
            this.isStaffHasPermissionToViewStudentFees = true;
          } else {
            const teacherIsNotAssignToThisClassPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('teacherIsNotAssignToThisClassPleaseTryAgain')); 
            customToastr(teacherIsNotAssignToThisClassPleaseTryAgainTranslation, 'error');
          }
        },
        error => {
          this.isProcessing = false;
          this.selectedStaff = null;
          this.isStaffHasPermissionToViewStudentFees = true;
        }
      );
  }

  resetClassTeacherSelection() {
  this.selectedStaff = null;
  this.isStaffHasPermissionToViewStudentFees = true;
  this.staffsList = [];
  $('#search-staff-assign').val('');
}

  removeclassTeacherPopUp(id, pos) {
    this.delTeacherId = id;
    this.delTeacherPos = pos;
  }

  removeTeacherFromClass() {
    var classId = this.classSectionId;
    this.classManageService.removeteacher(classId, this.delTeacherId, this.delTeacherPos, localStorage.getItem('usertoken'))
      .subscribe(
        async (data: any) => {
          if (data.status == true) {
            const teacherRemovedFromThisClassSuccessfullyTranslation = await firstValueFrom(this.translate.get('teacherRemovedFromThisClassSuccessfully')); 
            customToastr(teacherRemovedFromThisClassSuccessfullyTranslation, 'success');
            $('#closeremoveTeacherpopup').trigger('click');
            this.getClassTeacherListByClass(classId);
          } else {
            const teacherIsNotRemovedFromThisClassPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('teacherIsNotRemovedFromThisClassPleaseTryAgain')); 
            customToastr(teacherIsNotRemovedFromThisClassPleaseTryAgainTranslation, 'error');
          }
        },
        error =>
          () => {
          }
      );
  }

  async updateClassOrder() {

    var classStdList = [];
    for (var i = 0; i < this.getClassListArray.length; i++) {
      classStdList.push({ className: this.getClassListArray[i].ClassName, pkClassStandardsId: this.getClassListArray[i].fkClassStandardsId, sequence: parseInt(this.getClassListArray[i].Sequence) });
    }
    let isEptyFieldsInArray = this.checkArrayHasEmptyData(classStdList, 'sequence');
    if (isEptyFieldsInArray !== true) {
       const pleaseProvideClassSequenceForTranslation = await firstValueFrom(this.translate.get('pleaseProvideClassSequenceFor')); 
      customToastr( pleaseProvideClassSequenceForTranslation + isEptyFieldsInArray.className, 'error');
      return;
    }

    let isUnique = this.getIsArrayItemsUnique(classStdList, 'sequence');
    if (isUnique.error === 'NOT_UNIQUE') {
      const classSequenceNumberForClassTranslation = await firstValueFrom(this.translate.get('classSequenceNumberForClass')); 
      const isNotUniquePleaseCheckTranslation = await firstValueFrom(this.translate.get('isNotUniquePleaseCheck'));
      customToastr(`${classSequenceNumberForClassTranslation} <b> ${isUnique.notUniqueItem.className} </b> ${isNotUniquePleaseCheckTranslation}`, 'error');
    }
    else if (isUnique.error === 'MISSING_SEQUENCE') {
      const classSequenceNumbersTranslation = await firstValueFrom(this.translate.get('classSequenceNumbers')); 
      const areMissingPleaseCheckTranslation = await firstValueFrom(this.translate.get('areMissingPleaseCheck'));
      customToastr( classSequenceNumbersTranslation + isUnique.missedSequence.join(',') + areMissingPleaseCheckTranslation, 'error')
    }
    else if (isUnique.error === 'NONE') {
      $('#classes-Status').show();
      this.classManageService.updateClassOrder(classStdList, localStorage.getItem('usertoken'))
        .subscribe(
          async (data: any) => {
            if (data.status == true) {
              const classesOrderSuccessfullyUpdatedTranslation = await firstValueFrom(this.translate.get('classesOrderSuccessfullyUpdated')); 
              customToastr(classesOrderSuccessfullyUpdatedTranslation, 'success');
              this.getClassList();
              this.enableClassSequence = false;
              $('#classes-Status').hide();
              // $('#classList').show();
              // $('#updateClassSequenceOrder').hide();
            } else {
             const classesOrderUpdateFailedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('classesOrderUpdateFailedPleaseTryAgain')); 
             customToastr(classesOrderUpdateFailedPleaseTryAgainTranslation, 'error');
            }
          },
          async error => {
            const classesOrderUpdateFailedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('classesOrderUpdateFailedPleaseTryAgain')); 
            customToastr(classesOrderUpdateFailedPleaseTryAgainTranslation, 'error');
          }
        );
    }
    else {
      const classSequenceNumbersAreNotUniquePleaseCheckTranslation = await firstValueFrom(this.translate.get('classSequenceNumbersAreNotUniquePleaseCheck')); 
      customToastr(classSequenceNumbersAreNotUniquePleaseCheckTranslation, 'error');
    }

  }
  getIsArrayItemsUnique(arr, uniqueKey) {
    const flagList = []
    for (let i = 0; i < arr.length; i++) {
      let item = arr[i];
      if (flagList.indexOf(parseInt(item[uniqueKey])) === -1) {
        flagList.push(parseInt(item[uniqueKey]))
      }
      else {
        return { error: 'NOT_UNIQUE', notUniqueItem: item }
      }

    }

    //flagList.sort(function(a, b){return a - b});
    let missingSequence = [];
    for (let i = 0; i < arr.length; i++) {
      if (flagList.indexOf(i + 1) === -1) {
        missingSequence.push(i + 1)
      }
    }
    if (missingSequence.length > 0) {
      return { error: 'MISSING_SEQUENCE', missedSequence: missingSequence }
    }

    return { error: 'NONE', missedSequence: missingSequence }
  }
  checkArrayHasEmptyData(arr, key) {
    for (let i = 0; i < arr.length; i++) {
      if (!arr[i][key]) {

        return arr[i];
      }
    }
    return true;
  }
  async updateSectionOrder() {
    var stdId = this.classStdId;

    var sectionList = [];

    for (var i = 0; i < this.getClassViewClassSectionArray.length; i++) {
      sectionList.push({ className: this.getClassViewClassSectionArray[i].className + '-' + this.getClassViewClassSectionArray[i].classSection, classId: this.getClassViewClassSectionArray[i].claaSectionId, sectionSequence: parseInt(this.getClassViewClassSectionArray[i].SectionSequence) });
    }
    let isEptyFieldsInArray = this.checkArrayHasEmptyData(sectionList, 'sectionSequence');
    if (isEptyFieldsInArray !== true) {
      const pleaseProvideSectionSequenceForTranslation = await firstValueFrom(this.translate.get('pleaseProvideSectionSequenceFor'));
      customToastr(pleaseProvideSectionSequenceForTranslation + ' ' + isEptyFieldsInArray.className, 'error');
      return;
    }

    let isUnique = this.getIsArrayItemsUnique(sectionList, 'sectionSequence');
    if (isUnique.error === 'NOT_UNIQUE') {
      const translation = await firstValueFrom(
        this.translate.get('sectionSequenceNumberError', { className: isUnique.notUniqueItem.className })
      );
      customToastr(translation, 'error');

    }
    else if (isUnique.error === 'MISSING_SEQUENCE') {
      const missingSequences = isUnique.missedSequence.join(',');

      const translation = await firstValueFrom(
        this.translate.get('sectionSequenceNumbersMissing', { missingSequences })
      );

      customToastr(translation, 'error');

    }
    else if (isUnique.error === 'NONE') {
      $('#sectionOrder-Status').show();
      this.classManageService.updateClassSectionOrder(sectionList, localStorage.getItem('usertoken'))
        .subscribe(
          async (data: any) => {
            if (data.status == true) {
              const classSectionOrderSuccessfullyUpdatedTranslation = await firstValueFrom(this.translate.get('classSectionOrderSuccessfullyUpdated')); 
              customToastr(classSectionOrderSuccessfullyUpdatedTranslation, 'success');
              $('#sectionOrder-Status').hide();
              // $('#updateSectionSequence').hide();
              // $('#section-List').show();
              this.getSectionListClassView(this.classStdId);
              this.enableSectionSequence = false;
            } else {
              const classSectionIsNotOrderedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('classSectionIsNotOrderedPleaseTryAgain')); 
              customToastr(classSectionIsNotOrderedPleaseTryAgainTranslation, 'error');
            }
          },
         async error => {
            const classSectionIsNotOrderedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('classSectionIsNotOrderedPleaseTryAgain')); 
            customToastr(classSectionIsNotOrderedPleaseTryAgainTranslation, 'error');
          }
        );
    }
    else {
      const sectionSequenceNumbersAreNotUniquePleaseCheckTranslation = await firstValueFrom(this.translate.get('sectionSequenceNumbersAreNotUniquePleaseCheck'));
       customToastr(sectionSequenceNumbersAreNotUniquePleaseCheckTranslation, 'error');
    }
  }

  async updateSubjectName() {
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $('#updateSub').text(translatedText); });
    $('#updateSub').attr('disabled', true);
    var subjectName = $('#subject').val();
    if (this.formValidator.validateIsData(subjectName)) {
      this.classManageService.updateSubject(this.getSubjectId, subjectName, localStorage.getItem('usertoken'))
        .subscribe(
          async (data: any) => {
            this.translate.get('update').subscribe((translatedText: string) => { $('#updateSub').text(translatedText); });
            $('#updateSub').attr('disabled', false);
            if (data.status == true) {
              $('#closeUpdateSubject').trigger('click');
              const subjectUpdatedSuccessfullyTranslation = await firstValueFrom(this.translate.get('subjectUpdatedSuccessfully')); 
              customToastr(subjectUpdatedSuccessfullyTranslation, 'success');
              this.listAllSubjects();
            } else if (data.status == false) {
              const subjectIsAlreadyExistPleaseTryDifferentSubjectNameTranslation = await firstValueFrom(this.translate.get('subjectIsAlreadyExistPleaseTryDifferentSubjectName')); 
              customToastr(subjectIsAlreadyExistPleaseTryDifferentSubjectNameTranslation, 'error');
            } else {
              const subjectIsNotUpdatedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('subjectIsNotUpdatedPleaseTryAgain')); 
              customToastr(subjectIsNotUpdatedPleaseTryAgainTranslation, 'error');
            }
          },
          error =>
            () => {
            }
        );
    } else {
      this.translate.get('update').subscribe((translatedText: string) => { $('#updateSub').text(translatedText); });
      $('#updateSub').attr('disabled', false);
      const pleaseEnterSubjectNameTranslation = await firstValueFrom(this.translate.get('pleaseEnterSubjectName')); 
      customToastr(pleaseEnterSubjectNameTranslation, 'error');
    }
  }

  /*Data table operation*/
  destroyDataTable(table) {
    $('#' + table).DataTable().destroy();
  }

  initializeDataTable(table) {
  setTimeout(() => {
    this.translate.get([
      'dataTables.processing',
      'dataTables.search',
      'dataTables.lengthMenu',
      'dataTables.info',
      'dataTables.infoEmpty',
      'dataTables.infoFiltered',
      'dataTables.paginate.first',
      'dataTables.paginate.last',
      'dataTables.paginate.next',
      'dataTables.paginate.previous',
    ]).subscribe(translations => {
      $('#' + table).DataTable({
        order: [[0, 'asc']],
        language: {
          processing: translations['dataTables.processing'],
          search: translations['dataTables.search'],
          lengthMenu: translations['dataTables.lengthMenu'],
          info: translations['dataTables.info'],
          infoEmpty: translations['dataTables.infoEmpty'],
          infoFiltered: translations['dataTables.infoFiltered'],
          paginate: {
            first: translations['dataTables.paginate.first'],
            last: translations['dataTables.paginate.last'],
            next: translations['dataTables.paginate.next'],
            previous: translations['dataTables.paginate.previous']
          },
        },
        colReorder: true
      });
    });
  }, 500);
}

  studentListClassSectionStatus = true;

  async ViewstudentListClassSection() {
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $('#viewstud').text(translatedText); });
    $('#viewstud').attr('disabled', true);
    this.getClassSectionStudentListArray = [];
    this.destroyDataTable('view-class-detail-student-table');
    if (this.getSeletedSectionClassIdView != undefined) {
      this.classManageService.getStudentListClassSection(this.getSchoolId, this.academicId, this.getSeletedSectionClassIdView, this.getAuthToken)
        .subscribe(
          (data: any) => {
            this.translate.get('viewStudents').subscribe((translatedText: string) => { $('#viewstud').text(translatedText); });
            $('#viewstud').attr('disabled', false);
            if (data.data && data.data.length > 0) {
              this.getClassSectionStudentListArray = JSON.parse(JSON.stringify(data.data));
            }
            this.initializeDataTable('view-class-detail-student-table');

            $('#class-detail-student-detail-tab').show();
            if (this.getClassSectionStudentListArray.length == 0) {
              //$('#studentList').show();
              this.studentListClassSectionStatus = true;
            } else {
              //$('#studentList').hide();
              this.studentListClassSectionStatus = false;
            }
          },
          error =>
            () => {
            }
        );
    } else {
      this.translate.get('viewStudents').subscribe((translatedText: string) => { $('#viewstud').text(translatedText); });
      $('#viewstud').attr('disabled', false);
      const pleaseSelectSectionTranslation = await firstValueFrom(this.translate.get('pleaseSelectSection')); 
      customToastr(pleaseSelectSectionTranslation, 'error');
    }
  }

  /*Time Table Module*/

  DAYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
  DAYS_KAMEL = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

  updateOrCreateConfig(config) {

    this.classManageService.configTimeTable(config, this.getAuthToken)
      .subscribe(
        async (data: any) => {
          if (data.status == true) {
            const timeTableConfiguredSuccessfullyTranslation = await firstValueFrom(this.translate.get('timeTableConfiguredSuccessfully')); 
            customToastr(timeTableConfiguredSuccessfullyTranslation, 'success');
            $('#closeTimeTableConfig').trigger('click');
          } else {
            $('#saveTimetableConfig').show();
            const timeTableNotConfiguredPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('timeTableNotConfiguredPleaseTryAgain')); 
            customToastr(timeTableNotConfiguredPleaseTryAgainTranslation, 'error');
          }
        },
        error =>
          () => {
          }
      );
  }

  categoryInfoTimeTable() {
    var h = this;
    $('body').on('click', '#selectCategory', function () {
      var categoryId = $(this).attr('categoryId');
      var categoryName = $(this).attr('categoryName');
      $('#saveTimetableConfig').hide();
      h.getTimetableConfig(categoryId, categoryName);
    });

    $('#category-info-time-table').on('change', function () {
      var categoryId = $(this).val();
      var categoryName = $(this).find('option[value=' + categoryId + ']').text();
      $('#saveTimetableConfig').hide();
      h.getTimetableConfig(categoryId, categoryName);
    });

  }

  getTimetableConfig(categoryId, categoryName) {
    this.classManageService.getTimeTable(categoryId, this.getAuthToken)
      .subscribe(
        async (data: any) => {
          $('#category-info-time-table').val(categoryId);
          $('#time-period,#class-duration,#break-duration,#lunch-duration').val('');
          $('#timeOfperied').empty();
          $('.configDay').prop('checked', false);
          if (data.status == true && data.message != 'TimetableConfigurationNotExist') {
            $('#saveTimetableConfig').show();
            $('#saveTimetableConfig').attr('action', 'update');
            this.bindTimetableConfig(data.rows);
          } else {
            $('#saveTimetableConfig').attr('action', 'create');
            $('#saveTimetableConfig').show();
            const translation = await firstValueFrom(
              this.translate.get('timetableConfigNotExist', { categoryName })
            );
            customToastr(translation, 'info', 'Set Configuration');
          }
        },
        error =>
          () => {
          }
      );
    /*$.ajax({
      url:'/gettimetableconfig?categoryId='+categoryId,
      type:'GET',
      datatype:'JSON',
      success:function(response){
        $("#category-info-time-table").val(categoryId);
        $("#time-period,#class-duration,#break-duration,#lunch-duration").val('');
        $('#timeOfperied').empty();
        $(".configDay").prop('checked',false);
        if(response && response.status && response.rows){
          $("#saveTimetableConfig").attr('action','update')
          this.bindTimetableConfig(response.rows)
        }
        else{
          $("#saveTimetableConfig").attr('action','create')
          customToastr('Timetable configuration not exist for <span class="text-bold">'+categoryName+'</span>. Please create',"Set Configuration","info");
        }
      },
      error : function (status) {
        const serverNotReachableToLoadConfigurationTranslation = await firstValueFrom(this.translate.get('serverNotReachableToLoadConfiguration')); customToastr(serverNotReachableToLoadConfigurationTranslation, 'error');
      }
    })*/
  }

  bindTimetableConfig(config) {
    $('#time-period').val(config.numberOfPeriods || '');
    for (var i = 0; i < this.DAYS.length; i++) {
      $('#' + this.DAYS[i]).prop('checked', config[this.DAYS[i]]);
    }
    var arr = [];
    for (var p = 0; p < config.periods.length; p++) {
      var timePeriodTemplate = '<div class="start-end-time-table-container periods-config">' +
        '<div class="col-md-1" style="color: gray;"><p style="font-weight: 800;" id="periodNumber" num="' + config.periods[p].periodNumber + '">' + config.periods[p].periodNumber + '.</p></div>' +
        '<div class="form-group col-md-3" style="padding: 0px 0px;"><input type="text" placeholder="Start Time" class="form-control start-time-table plug-time startTime" style="border: 1px solid gainsboro;font-size: small;padding: 0 0 0 12px;" id ="time' + config.periods[p].periodNumber + '" value="' + config.periods[p].periodStart + '"></div>' +
        '<div class="col-md-1" style="color: gray;"><h5>TO</h5></div><div class="form-group col-md-3" style="padding: 0px 0px;"><input type="text" placeholder="End Time"class="form-control end-time-table plug-time endTime" style="border: 1px solid gainsboro;font-size: small;padding: 0 0 0 12px;" value="' + config.periods[p].periodEnd + '"></div>' +
        '<div class="form-group col-md-4"><select value="' + config.periods[p].periodType + '" class="form-control category-selector category-selector-type" style="border: 1px solid gainsboro;font-size: small;" id="periodType">' +
        '<option value="none">Select Type</option><option value="1">CLASS</option><option value="0">BREAK</option><option value="2">LUNCH BREAK</option>' +
        '</select></div>' +
        '</div>';
      var _timePeriodTemplate = $(timePeriodTemplate);
      _timePeriodTemplate.find('#periodType option[value=' + config.periods[p].periodType + ']').attr('selected', 'selected');
      arr.push(_timePeriodTemplate);
    }
    $('#timeOfperied').append(arr);
    $('.plug-time').timepicker({
      timeFormat: 'H:i',
      defaultTime: '07:00',
      step: 5
    });
    if (config.classDuration) {
      $('#class-duration').val(config.classDuration);
    }
    if (config.breakDuration) {
      $('#break-duration').val(config.breakDuration);
    }
    if (config.lunchBreakDuration) {
      $('#lunch-duration').val(config.lunchBreakDuration);
    }
  }

  /*day = {monday:false,tuesday:false,wednesday:false,thursday:false,friday:false,saturday:false,sunday:false};
    classDuration = "";
    breakDuration = "";
    lunchDuration = "";
    numberOfPeriod = [];
    startTimeChange = "";
    endTimeChange = "";
    selectType = "";
    multiplePeriod = {startTime:"07:00",endTime:"",type:"1"};
    configureTimeTable(){
      var endTimeList = [];

      if (this.endTimeChange && this.endTimeChange.length > 0){
        for (var i = 0; i < this.endTimeChange.length; i++){
          endTimeList.push(this.endTimeChange[i]);
        }
      }
    }
    noOfPeriod(noPeriod){
      this.numberOfPeriod = [];
      for (var i=0; i < noPeriod; i++){
        this.numberOfPeriod.push(JSON.parse(JSON.stringify(this.multiplePeriod)));
      }
      setTimeout(function () {
        $('.plug-time').timepicker({
          step:5
        });
      },10);
    }*/
  timeTableSetting() {
    $('#time-period').keyup(async function (event) {
      var numbersOfTimePeriods = this.value = this.value.replace(/[^0-9\.]/g, '');
      var timePeriods = parseInt(numbersOfTimePeriods);
      var start = 0;
      var insert = true;
      if (numbersOfTimePeriods.trim() != '' && isNaN(timePeriods) == false) {
        if (timePeriods <= 15) {
          var periodsDom = $('#timeOfperied').find('.start-end-time-table-container');
          if (periodsDom && periodsDom.length > 0) {
            if (timePeriods == periodsDom.length) {
              insert = false;
            } else if (timePeriods > periodsDom.length) {
              start = periodsDom.length;
            } else {
              periodsDom.slice(timePeriods - periodsDom.length).remove();
              insert = false;
            }
          }
          $('#saveTimetableConfig').show();
          if (insert) {
            for (var i = start; i < timePeriods; i++) {
              var timePeriodTemplate = '<div class="start-end-time-table-container periods-config">' +
                '<div class="col-md-1" style="color: gray;"><p style="font-weight: 800;" id="periodNumber" num="' + (i + 1) + '">' + (i + 1) + '.</p></div>' +
                '<div class="form-group col-md-3" style="padding: 0px 0px;"><input type="text" placeholder="Start Time" class="form-control start-time-table plug-time starttime" style="border: 1px solid gainsboro;font-size: small;padding: 0 0 0 12px;" id ="time' + i + '"></div>' +
                '<div class="col-md-1" style="color: gray;"><h5>TO</h5></div>' +
                '<div class="form-group col-md-3" style="padding: 0px 0px;"><input type="text" placeholder="End Time" class="form-control end-time-table plug-time endtime" style="border: 1px solid gainsboro;font-size: small;padding: 0 0 0 12px;"></div>' +
                '<div class="form-group col-md-4"><select class="form-control category-selector category-selector-type" id="periodType" style="border: 1px solid gainsboro;font-size: small;">' +
                '<option value="none" >Select Type</option><option value="1">CLASS</option><option value="0">BREAK</option><option value="2">LUNCH BREAK</option>' +
                '</select></div>' +
                '</div>';
              $('#timeOfperied').append(timePeriodTemplate);
            }
            $('#timeOfperied').find('option[value=1]').attr('selected', 'selected');
            $('.plug-time').timepicker({
              timeFormat: 'H:i',
              defaultTime: '07:00',
              step: 5
            });
          }
        } else {
          const numberOfPeriodsShouldNotBeMoreThan15PeriodsTranslation = await firstValueFrom(this.translate.get('numberOfPeriodsShouldNotBeMoreThan15Periods')); 
          customToastr(numberOfPeriodsShouldNotBeMoreThan15PeriodsTranslation, 'error');
        }
      }
    });
    $('body').on('keyup', '#break-duration', function () {
      var periodDuration = $(this).val();
      periodDuration = $(this).val().replace(/[^0-9\.]/g, '');
      var periodDurationInt = parseInt(periodDuration);
      $(this).val(periodDuration);
      if (periodDuration.trim() != '' && isNaN(periodDurationInt) == false && periodDurationInt >= 10) {
        /* if(periodDurationInt >= 61){
         toastr.error("Please provide valid duration below 60 minutes");
         }
         else{*/
        var existing = $('#timeOfperied').find('.starttime').first().val() || '07:00';
        $('#timeOfperied').find('.starttime').first().val(existing).trigger('change');
        //}
      }
    });

    $('body').on('keyup', '#lunch-duration', function () {
      var periodDuration = $(this).val();
      periodDuration = $(this).val().replace(/[^0-9\.]/g, '');
      var periodDurationInt = parseInt(periodDuration);
      $(this).val(periodDuration);
      if (periodDuration.trim() != '' && isNaN(periodDurationInt) == false && periodDurationInt >= 10) {
        /* if(periodDurationInt >= 61){
         toastr.error("Please provide valid duration below 60 minutes");
         }
         else{*/
        var existing = $('#timeOfperied').find('.starttime').first().val() || '07:00';
        $('#timeOfperied').find('.starttime').first().val(existing).trigger('change');
        //}
      }
    });

    $('body').on('change', '#periodType', function () {
      if ($(this).val() != 'none') {
        switch ($(this).val()) {
          case '1':
            var periodDuration = $('#class-duration').val();
            periodDuration = $('#class-duration').val().replace(/[^0-9\.]/g, '');
            var periodDurationInt = parseInt(periodDuration);
            if (periodDuration.trim() != '' && isNaN(periodDurationInt) == false && periodDurationInt >= 10) {
              //if(periodDurationInt <= 60){
              var time = $(this).parent().parent().find('.starttime').val().split(':');
              var m = momentJs();
              m.hours(time[0]);
              m.minutes(time[1]);
              m.minutes(m.minutes() + periodDurationInt);

              $(this).parent().parent().find('.endtime').val(m.format('HH:mm')).trigger('change');
              //}
            }
            break;
          case '0':
            var periodDuration = $('#break-duration').val();
            periodDuration = $('#break-duration').val().replace(/[^0-9\.]/g, '');
            var periodDurationInt = parseInt(periodDuration);
            if (periodDuration.trim() != '' && isNaN(periodDurationInt) == false && periodDurationInt >= 10) {
              //if(periodDurationInt <= 60){
              var time = $(this).parent().parent().find('.starttime').val().split(':');
              var m = momentJs();
              m.hours(time[0]);
              m.minutes(time[1]);
              m.minutes(m.minutes() + periodDurationInt);

              $(this).parent().parent().find('.endtime').val(m.format('HH:mm')).trigger('change');
              //}
            }
            break;
          case '2':
            var periodDuration = $('#lunch-duration').val();
            periodDuration = $('#lunch-duration').val().replace(/[^0-9\.]/g, '');
            var periodDurationInt = parseInt(periodDuration);
            if (periodDuration.trim() != '' && isNaN(periodDurationInt) == false && periodDurationInt >= 10) {
              //if(periodDurationInt <= 60){
              var time = $(this).parent().parent().find('.starttime').val().split(':');
              var m = momentJs();
              m.hours(time[0]);
              m.minutes(time[1]);
              m.minutes(m.minutes() + periodDurationInt);

              $(this).parent().parent().find('.endtime').val(m.format('HH:mm')).trigger('change');
              //}
            }
            break;
        }
      }
    });

    $('#class-duration').on('keyup', function () {
      var periodDuration = $('#class-duration').val();
      periodDuration = $('#class-duration').val().replace(/[^0-9\.]/g, '');
      var periodDurationInt = parseInt(periodDuration);
      $('#class-duration').val(periodDuration);
      if (periodDuration.trim() != '' && isNaN(periodDurationInt) == false && periodDurationInt >= 10) {
        /*if(periodDurationInt >= 61){
         toastr.error("Please provide valid duration below 60 minutes");
         }
         else{*/
        var existing = $('#timeOfperied').find('.starttime').first().val() || '07:00';
        $('#timeOfperied').find('.starttime').first().val(existing).trigger('change');
        //}
      }
    });
    $('body').on('change', '.starttime', async function () {
      var div = $(this).parent().parent();
      var periodDuration = $('#class-duration').val();
      periodDuration = $('#class-duration').val().replace(/[^0-9\.]/g, '');
      $('#class-duration').val(periodDuration);
      var periodDurationInt = parseInt(periodDuration);
      if (periodDuration.trim() != '' && isNaN(periodDurationInt) == false /*&& periodDurationInt <= 60*/ && periodDurationInt >= 10) {
        var parentDiv = $(div).find('.endtime');
        var time = $(this).val().split(':');
        var m = momentJs();
        m.hours(time[0]);
        m.minutes(time[1]);
        m.minutes(m.minutes() + periodDurationInt);

        $(div).find('.endtime').val(m.format('HH:mm')).trigger('change');
      } else {
        $('.plug-time').val('');
        const pleaseProvideValidPeriodDurationTranslation = await firstValueFrom(this.translate.get('pleaseProvideValidPeriodDuration')); 
        customToastr(pleaseProvideValidPeriodDurationTranslation, 'error');
      }
    });
    $('body').on('change', '.endtime', function () {
      var div = $(this).parent().parent();

      $(div).next().find('.plug-time').first().val($(this).val());
      $(div).next().find('#periodType').trigger('change');
    });
  }

  configData;

  timeTableConfig() {
    var h = this;
    $('#saveTimetableConfig').on('click',async function () {

      var category = $('#category-info-time-table').val();
      if (category != 0) {
        var numberOfPeriods = $('#time-period').val();
        if (numberOfPeriods != '') {
          var days = $('.configDay');
          var daysObj = {};
          var isValid = false;
          var numberOfDays = 0;
          for (var i = 0; i < days.length; i++) {
            var day = $(days[i]);

            daysObj[day.attr('day')] = day.prop('checked') ? 1 : 0;
            numberOfDays += day.prop('checked') ? 1 : 0;
            if (!isValid && day.prop('checked')) {
              isValid = true;
            }
          }

          if (isValid) {
            var periodsDivs = $('.periods-config');
            var periods = [];
            var isValidPeriod = true;
            for (var j = 0; j < periodsDivs.length; j++) {
              var div = $(periodsDivs[j]);
              var startTime = $(div.find('.plug-time')[0]).val();
              var endTime = $(div.find('.plug-time')[1]).val();
              var periodType = div.find('#periodType').val();
              var periodNumber = div.find('#periodNumber').attr('num');
              if (startTime == '' || endTime == '' || periodType == 'none') {
                isValidPeriod = false;
              }
              periods.push({
                periodStart: startTime,
                periodEnd: endTime,
                periodType: parseInt(periodType),
                periodNumber: parseInt(periodNumber)
              });
            }

            if (isValidPeriod) {
              $('#saveTimetableConfig').hide();
              var config = {
                'categoryId': parseInt(category),
                'days': daysObj,
                'numberOfDays': numberOfDays,
                'numberOfPeriods': parseInt(numberOfPeriods),
                'periods': periods,
                'classDuration': $('#class-duration').val(),
                'breakDuration': $('#break-duration').val(),
                'lunchBreakDuration': $('#lunch-duration').val()
              };
              h.configData = config;
              if ($(this).attr('action') != 'update') {

                h.updateOrCreateConfig(config);
              } else {
                var categoryName = $('#category-info-time-table option:selected').text();
                h.classManageService.getClassesOfCategory(category, h.getAuthToken)
                  .subscribe(
                    (data: any) => {
                      if (data && data.status == true && data.rows.length > 0) {
                        var classArr = [];
                        data.rows.forEach(function (classObj, index) {
                          if (classArr.indexOf(classObj.classNumber + classObj.classDivision) == -1) {
                            classArr.push(classObj.classNumber + '-' + classObj.classDivision);
                          }
                        });
                        var classesText = classArr.length > 1 ? 'classes' : 'class';
                        $('#action-message').modal('show');
                        $('#action-message-info').html('Updating ' + categoryName + ' category Will affect <b>' + classArr.join(',') + ' </b> ' + classesText + ' timetable, <b>Do you want to continue?</b>');

                      } else {
                        h.updateOrCreateConfig(config);
                      }
                    },
                    error =>
                      () => {
                      }
                  );
              }
            } else {
              const pleaseProvideAllPeriodsInformationTranslation = await firstValueFrom(this.translate.get('pleaseProvideAllPeriodsInformation')); 
              customToastr(pleaseProvideAllPeriodsInformationTranslation, 'error');
            }
          } else {
            const pleaseSelectWorkingDaysTranslation = await firstValueFrom(this.translate.get('pleaseSelectWorkingDays')); 
            customToastr(pleaseSelectWorkingDaysTranslation, 'error');
          }
        } else {
          const pleaseEnterNumberOfPeriodsTranslation = await firstValueFrom(this.translate.get('pleaseEnterNumberOfPeriods')); 
          customToastr(pleaseEnterNumberOfPeriodsTranslation, 'error');
        }
      } else {
        const pleaseSelectACategoryTranslation = await firstValueFrom(this.translate.get('pleaseSelectACategory')); 
        customToastr(pleaseSelectACategoryTranslation, 'error');
      }

    });
  }

  changeTimeTableConfig() {
    this.updateOrCreateConfig(this.configData);
  }

  configButtonShow() {
    $('#saveTimetableConfig').show();
  }

  /*End of configuration Time table*/
  /*Time Table for class*/
  classStdSectionId = '';

  ViewClassTimetable() {
    this.classStdSectionId = $('#sectionOfClass').val();
  }

  getNumberTitle(num) {
    if (num == 1) {
      return num + 'st';
    } else if (num == 2) {
      return num + 'nd';
    } else if (num == 3) {
      return num + 'rd';
    } else if (num > 3 && num < 21) {
      return num + 'th';
    } else {
      return num + '';
    }
  }


  editButtonHide() {
    $('#msghide').hide();
    $('#savettforupadte').hide();
    $('#edit-timetable').hide();
    $('#saveTimetable').hide();
  }


  bindTimetable(timetable, classId, translations) {

    //$("#edit-timetable").hide();
    this.translate.get('edit').subscribe((translated) => {
        this.renderer.setAttribute(
          this.el.nativeElement.querySelector('#edit-timetable'),
          'value',
          translated
        );
      });
    $('#saveTimetable').attr('classId', classId);
    $('#savettforupadte').attr('classId', classId);
    var row = '';
    this.staffTitle = 'Teacher';
    $('#timetable tbody').html(row);
    for (var p = 0; p < timetable.numberOfPeriods; p++) {
      var period = p + 1;
      row += `
        <tr class="active" id="period_${period}">
        <td style="border-right:1px solid #DADADA"><lable>${ this.getNumberTitle(period)}</lable></td>
        <td id="td${period}_1" class="disableDay1" style="border-right:1px solid #DADADA">
        <p class="copy-timetable-slot"><i class="fa fa-files-o" aria-hidden="true" title="Copy" style="float:right;color:#969c9c;cursor: pointer;"></i></p>
        <p class="paste-timetable-slot hide"><i class="fa fa-clipboard paste-icon-color" aria-hidden="true" title="Paste" style="float:right;color:#969c9c;cursor: pointer;"></i></p>
        <span><i>${translations['subject']}: </i></span><select class="timetable_subjects" style="width: 10em;" day="1" id="${period}_1">
        <option value="none">${translations['na']}</option>
        </select>&nbsp;
        <br>
        <span><i>${translations['teacher']}: </i></span><select class="timetable_teachers" style="width: 10em;" day="1" id="teachers${period}_1">
        <option value="none">${translations['na']}</option>
        </select>&nbsp;
        </td>

        <td id="td${period}_2" class="disableDay2">
        <p class="copy-timetable-slot"><i class="fa fa-files-o" aria-hidden="true" title="Copy" style="float:right;color:#969c9c;cursor: pointer;"></i></p>
        <p class="paste-timetable-slot hide"><i class="fa fa-clipboard paste-icon-color" aria-hidden="true" title="Paste" style="float:right;color:#969c9c;cursor: pointer;"></i></p>
        <span><i>${translations['subject']}: </i></span><select class="timetable_subjects" style="width: 10em;" day="2" id="${period}_2">
        <option value="none">${translations['na']}</option>
        </select>&nbsp;
        <br>
        <span><i>${translations['teacher']}: </i></span><select class="timetable_teachers" style="width: 10em;" day="2" id="teachers${period}_2">
        <option value="none">${translations['na']}</option>
        </select>&nbsp;
        </td>

        <td id="td${period}_3" class="disableDay3">
        <p class="copy-timetable-slot"><i class="fa fa-files-o" aria-hidden="true" title="Copy" style="float:right;color:#969c9c;cursor: pointer;"></i></p>
        <p class="paste-timetable-slot hide"><i class="fa fa-clipboard paste-icon-color" aria-hidden="true" title="Paste" style="float:right;color:#969c9c;cursor: pointer;"></i></p>
        <span><i>${translations['subject']}: </i></span><select class="timetable_subjects" style="width: 10em;" day="3" id="${period}_3">
        <option value="none">${translations['na']}</option>
        </select>&nbsp;
        <br>
        <span><i>${translations['teacher']}: </i></span><select class="timetable_teachers" style="width: 10em;" day="3" id="teachers${period}_3">
        <option value="none">${translations['na']}</option>
        </select>&nbsp;
        </td>

        <td id="td${period}_4" class="disableDay4">
        <p class="copy-timetable-slot"><i class="fa fa-files-o" aria-hidden="true" title="Copy" style="float:right;color:#969c9c;cursor: pointer;"></i></p>
        <p class="paste-timetable-slot hide"><i class="fa fa-clipboard paste-icon-color" aria-hidden="true" title="Paste" style="float:right;color:#969c9c;cursor: pointer;"></i></p>
        <span><i>${translations['subject']}: </i></span><select class="timetable_subjects" style="width: 10em;" day="4" id="${period}_4">
        <option value="none">${translations['na']}</option>
        </select>&nbsp;
        <br>
        <span><i>${translations['teacher']}: </i></span><select class="timetable_teachers" style="width: 10em;" day="4" id="teachers${period}_4">
        <option value="none">${translations['na']}</option>
        </select>&nbsp;
        </td>

        <td id="td${period}_5" class="disableDay5">
        <p class="copy-timetable-slot"><i class="fa fa-files-o" aria-hidden="true" title="Copy" style="float:right;color:#969c9c;cursor: pointer;"></i></p>
        <p class="paste-timetable-slot hide"><i class="fa fa-clipboard paste-icon-color" aria-hidden="true" title="Paste" style="float:right;color:#969c9c;cursor: pointer;"></i></p>
        <span><i>${translations['subject']}: </i></span><select class="timetable_subjects" style="width: 10em;" day="5" id="${period}_5">
        <option value="none">${translations['na']}</option>
        </select>&nbsp;
        <br>
        <span><i>${translations['teacher']}: </i></span><select class="timetable_teachers" style="width: 10em;" day="5" id="teachers${period}_5">
        <option value="none">${translations['na']}</option>
        </select>&nbsp;
        </td>

        <td id="td${period}_6" class="disableDay6">
        <p class="copy-timetable-slot"><i class="fa fa-files-o" aria-hidden="true"  title="Copy" style="float:right;color:#969c9c;cursor: pointer;"></i></p>
        <p class="paste-timetable-slot hide"><i class="fa fa-clipboard paste-icon-color" aria-hidden="true"  title="Paste" style="float:right;color:#969c9c;cursor: pointer;"></i></p>
        <span><i>${translations['subject']}: </i></span><select class="timetable_subjects" style="width: 10em;" day="6" id="${period}_6">
        <option value="none">${translations['na']}</option>
        </select>&nbsp;
        <br>
        <span><i>${translations['teacher']}: </i></span><select class="timetable_teachers" style="width: 10em;" day="6" id="teachers${period}_6">
        <option value="none">${translations['na']}</option>
        </select>&nbsp;
        </td>

        <td id="td${period}_7" class="disableDay7">
        <p class="copy-timetable-slot"><i class="fa fa-files-o" aria-hidden="true" title="Copy" style="float:right;color:#969c9c;cursor: pointer;"></i></p>
        <p class="paste-timetable-slot hide"><i class="fa fa-clipboard paste-icon-color" aria-hidden="true" title="Paste" style="float:right;color:#969c9c;cursor: pointer;"></i></p>
        <span><i>${translations['subject']}: </i></span><select class="timetable_subjects" style="width: 10em;" day="7" id="${period}_7">
        <option value="none">${translations['na']}</option>
        </select>&nbsp;
        <br>
        <span><i>${translations['teacher']}: </i></span><select class="timetable_teachers" style="width: 10em;" day="7" id="teachers${period}_7">
        <option value="none">${translations['na']}</option>
        </select>&nbsp;
        </td>

        </tr>`;
    }
    $('#timetable tbody').html(row);
    var current = momentJs();
    $('#timetable').find('[class^=disableDay]').addClass('text-left');
    $('.timetable_subjects').append(this.subjectHtml);
    $('.timetable_subjects').attr('classId', classId);
    $('.timetable_teachers').attr('classId', classId);
    $('#timetable').find('.disableDay' + current.day()).addClass('timetable-current-day');

    if (!timetable.isTimetable) {
      //$('.paste-timetable-slot').addClass('hide');

      $('#edit-timetable').hide();
      $('#saveTimetable').hide();
      $('#savettforupadte').hide();
      $('#timetable').removeClass('timetable-view');
      for (var i = 0; i < timetable.periods.length; i++) {
        $('#timetable tbody').find('#period_' + (i + 1)).attr('periodId', timetable.periods[i].periodId);
        $('#timetable tbody').find('#period_' + (i + 1)).find('select').attr('periodId', timetable.periods[i].periodId);
        $('#timetable tbody').find('#period_' + (i + 1)).find('select').attr('periodStart', timetable.periods[i].periodStart);
        $('#timetable tbody').find('#period_' + (i + 1)).find('select').attr('periodEnd', timetable.periods[i].periodEnd);
        $($('#timetable tbody').find('#period_' + (i + 1)).find('td')[0]).append('<br><label class="timeperiod" style="width:76px;">' + timetable.periods[i].periodStart + ' - ' + timetable.periods[i].periodEnd + '</label>');
        if (timetable.periods[i].periodType != 1) {
          var breakTr = $('#timetable tbody').find('#period_' + (i + 1)).find('[class^=disableDay]');
          breakTr.removeClass('text-left');
          var breakD = timetable.periods[i].periodType == 0 ? translations.break : translations.lunchBreak;
          breakTr.append('<p style=\'color: var(--brand-primary-color);\'>' + breakD + '</p>');
          breakTr.find('select,span').hide();
          breakTr.find('.copy-timetable-slot,.paste-timetable-slot').remove();
        }
      }
    } else {
      $('#edit-timetable').show();
      $('#savettforupadte').hide();
      $('.edit-time-table').addClass('hide');
      $('#timetable').addClass('timetable-view');
      $('.copy-timetable-slot').hide();
      //$(".copy-timetable-slot").hide();
      //$("#edit-timetable").show();
      var once = true;

      for (var da in timetable.periods) {
        for (var pe in timetable.periods[da]) {
          if (timetable.periods[da][pe].subjectId != null) {
            $('#' + pe + '_' + da).val(timetable.periods[da][pe].subjectId || 'none');
          }

          $('#teachers' + pe + '_' + da).append(this.staffOptions[timetable.periods[da][pe].subjectId]);
          $('#teachers' + pe + '_' + da).val(timetable.periods[da][pe].staffId || 'none');

          if (da == current.day()) {
            var sTime = timetable.periods[da][pe].periodStart.split(':');
            var eTime = timetable.periods[da][pe].periodEnd.split(':');

            var mStart = current.clone();
            mStart.hours(sTime[0]);
            mStart.minutes(sTime[1]);
            var mEnd = current.clone();
            mEnd.hours(eTime[0]);
            mEnd.minutes(eTime[1]);
            if (current.isAfter(mStart) && current.isBefore(mEnd)) {
              $('#' + pe + '_' + da).parent().addClass('timetable-current-period');//.attr('title','Currently running period')
            }
          }

          if (once) {
            $('#timetable tbody').find('#period_' + pe).attr('periodId', timetable.periods[da][pe].periodId);
            $('#timetable tbody').find('#period_' + pe).find('select').attr('periodId', timetable.periods[da][pe].periodId);
            $('#timetable tbody').find('#period_' + pe).find('select').attr('periodStart', timetable.periods[da][pe].periodStart);
            $('#timetable tbody').find('#period_' + pe).find('select').attr('periodEnd', timetable.periods[da][pe].periodEnd);
            $($('#timetable tbody').find('#period_' + pe).find('td')[0]).append('<br><label class="timeperiod" style="width:76px;">' + timetable.periods[da][pe].periodStart + ' - ' + timetable.periods[da][pe].periodEnd + '</label>');
            if (timetable.periods[da][pe].periodType != 1) {
              var breakTr2 = $('#timetable tbody').find('#period_' + pe).find('[class^=disableDay]');
              breakTr2.removeClass('text-left');
              var breakD2 = timetable.periods[da][pe].periodType == 0 ? translations.break : translations.lunchBreak;
              breakTr2.append('<p style=\'color: var(--brand-primary-color);\'>' + breakD2 + '</p>');
              breakTr2.find('select,span').hide();
              breakTr2.find('.copy-timetable-slot,.paste-timetable-slot').remove();
            }
          }
        }
        once = false;
      }
    }
    $('.timetable_subjects[value=""]').find('option[value=none]').attr('selected', 'selected');
    this.DAYS.forEach(function (day, index) {
      if (timetable[day] == 0) {
        $('.disableDay' + (index + 1)).addClass('hide');
        $('.disableDay' + (index + 1)).find('select').attr('day', 'invalid');
        $('.disableDay' + (index + 1)).find('select,p').hide();
        $('#timetablethday' + (index + 1)).addClass('hide');
      } else {
        $('#timetablethday' + (index + 1)).removeClass('hide');
      }
    });
    $('#timetable tbody').find('[class^=disableDay]').hover(function () {
      var title = '';
      if (!$(this).find('.timetable_subjects').is(':hidden')) {

        if ($(this).find('.timetable_subjects').val() == 'none') {
          title += `${translations.subjectNotAssigned}\n`;
        }

        if ($(this).find('.timetable_teachers').val() == 'none') {
          title += `${translations.teacherNotAssigned}`;
        }
      }
      $(this).attr('title', title);
    }, function () {
    });
    $('.timetable-current-period').hover(function () {
      $(this).attr('title', translations.currentlyRunning);
    }, function () {

    });
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvents(event) {
    if (event.key == 'Escape' && this.copyEscape == true) {
      $('#msghide').hide();
      this.clearCopyTimeTableSlot();
      this.copyEscape = false;
    } else if (event.key == 'Enter' && event.target.id == 'search-staff-assign') {
      if (event.target.value && event.target.value != '') {
        this.searchClassTeacher(event.target.value);
      }
    }
  }

  clearCopyTimeTableSlot() {
    $('.copy-timetable-slot').show();
    $('.paste-timetable-slot').addClass('hide');
  }

  loadSubjects_class(classId, callback) {
    var staffOptions = {};
    this.classManageService.fetchSubjectOfClass(classId, this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.subjectHtml = '';
          if (data.status && data.rows && data.rows.length > 0) {
            for (var s = 0; s < data.rows.length; s++) {
              this.subjectHtml += '<option value="' + data.rows[s].subjectId + '">' + data.rows[s].subject + '</option>';
            }
          }
          if (data.status && data.staff && data.staff.rows) {

            for (var st in data.staff.rows) {
              if (data.staff.rows[st].length > 0) {
                staffOptions[st] = '';
                data.staff.rows[st].forEach(function (staff) {
                  staffOptions[st] += '<option value="' + staff.staffId + '">' + staff.staffName + '</option>';
                });
              }
            }
          } else {
            staffOptions = {};
          }

          callback(staffOptions);
        },
        error =>
          () => {
          }
      );
    /*$.ajax({
      url:'/getsubjectsofclass?classId='+classId+'&getStaff=yes',
      type:'GET',
      success:function(status){

        if(status && status.rows && status.rows.length > 0){
          for(var s=0; s<status.rows.length; s++){
            subjectHtml += '<option value="'+status.rows[s].subjectId+'">'+status.rows[s].subject+'</option>';
          }
        }
        if(status && status.staff && status.staff.rows){
          for(var st in status.staff.rows){
            if(status.staff.rows[st].length > 0){
              staffOptions[st] = ''
              status.staff.rows[st].forEach(function(staff){
                staffOptions[st] += '<option value="'+staff.staffId+'">'+staff.staffName+'</option>';
              })
            }
          }
        }
        else staffOptions = null;

        callback(staffOptions)
      },
      error:function(err){
        const serverNotReachableToLoadClassSubjectsTranslation = await firstValueFrom(this.translate.get('serverNotReachableToLoadClassSubjects')); customToastr(serverNotReachableToLoadClassSubjectsTranslation, 'error');
        callback(null)
      }
    })*/
  }

  cancelEditButton() {
    //$('#msghide').hide();
    $('.paste-icon-color').hide();
    $('#edit-timetable').show();
    $('.edit-time-table').addClass('hide');
    $('.copy-timetable-slot').hide();
    $('#select-class-time').show();
    $('#addTimeTable').show();
    if ($(this).attr('value', 'Cancel')) {
      $('#timetable').addClass('timetable-view');
      $('#saveTimetable').hide();
      $('#savettforupadte').hide();
      $('#msghide').hide();

      this.translate.get('edit').subscribe((translated) => {
        this.renderer.setAttribute(
          this.el.nativeElement.querySelector(this),
          'value',
          translated
        );
      });
    } else {
      $('#timetable').removeClass('timetable-view');
      $('#saveTimetable').show();
      $('#savettforupadte').show();
      $('.paste-icon-color').hide();
      $('#msghide').hide();
      $(this).attr('value', 'Cancel');
    }
  }

  editTimeTable() {
    //$('.paste-icon-color').show();
    $('#edit-timetable').hide();
    $('.edit-time-table').removeClass('hide');
    $('.copy-timetable-slot').show();

    $('#select-class-time').hide();
    $('#addTimeTable').hide();

    if ($(this).attr('value', 'Edit')) {
      $('#timetable').removeClass('timetable-view');

      $('#saveTimetable').show();
      $('#savettforupadte').show();
      $('#msghide').hide();
      $(this).attr('value', 'Cancel');
    } else {
      $('#timetable').addClass('timetable-view');
      $('#saveTimetable').hide();
      $('#savettforupadte').hide();
      $('.paste-icon-color').hide();
      $('#msghide').hide();
      this.translate.get('edit').subscribe((translated) => {
        this.renderer.setAttribute(
          this.el.nativeElement.querySelector(this),
          'value',
          translated
        );
      });
    }
  }

  saveTimeTable() {


    $('#msghide').hide();
    $('.copy-timetable-slot').hide();
    $('.paste-timetable-slot').addClass('hide');

    var classId = $('#saveTimetable').attr('classId');
    var dataToSend = {
      'classId': parseInt(classId),
      'values': []
    };
    var rows = $('#timetable tbody').find('tr').find('.timetable_subjects');
    for (var r = 0; r < rows.length; r++) {
      var select = $(rows[r]);
      if (select.attr('day') != 'invalid') {
        var staff = select.parent().find('.timetable_teachers').val();
        dataToSend.values.push(
          {
            'day': parseInt(select.attr('day')),
            'periodId': parseInt(select.attr('periodId')),
            'subjectId': select.val() == 'none' ? null : parseInt(select.val()),
            'staffId': staff == 'none' ? null : parseInt(staff)
          }
        );
      }
    }
    this.classManageService.updateTimeTable(dataToSend, this.getAuthToken)
      .subscribe(
        async (data: any) => {
          if (data && data.status) {
            $('#edit-timetable').show();
            this.translate.get('edit').subscribe((translated) => {
              this.renderer.setAttribute(
                this.el.nativeElement.querySelector('#edit-timetable'),
                'value',
                translated
              );
            });
            $('#saveTimetable').hide();
            $('#savettforupadte').hide();
            $('#timetable').addClass('timetable-view');
            $('.edit-time-table').addClass('hide');
            $('#select-class-time').show();
            $('#addTimeTable').show();
            const timetableSuccessfullySavedTranslation = await firstValueFrom(this.translate.get('timetableSuccessfullySaved')); 
            customToastr(timetableSuccessfullySavedTranslation, 'success');
            this.getTimetable(classId);
          } else {
            const timetableNotSavedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('timetableNotSavedPleaseTryAgain')); 
            customToastr(timetableNotSavedPleaseTryAgainTranslation, 'error');
          }
        },

        error =>
          async () => {
            const serverNotReachableTranslation = await firstValueFrom(this.translate.get('serverNotReachable')); 
            customToastr(serverNotReachableTranslation, 'error');
          }
      );
  }


  removeTimeSlot() {
    this.classManageService.reomoveTimeSlotForStaff(this.removeStaffTimeSlotPeriod, this.getAuthToken)
      .subscribe(
        async (data: any) => {
          if (data && data.status == true) {

            const periodSuccessfullyRemovedNowYouCanAbleToAssignStaffForThisClassTranslation = await firstValueFrom(this.translate.get('periodSuccessfullyRemovedNowYouCanAbleToAssignStaffForThisClass')); 
            customToastr(periodSuccessfullyRemovedNowYouCanAbleToAssignStaffForThisClassTranslation, 'success');
            this.openTimetableTimeClashPopup = false;
          } else {
            const periodNotRemovedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('periodNotRemovedPleaseTryAgain')); 
            customToastr(periodNotRemovedPleaseTryAgainTranslation, 'error');
          }
        },
        error =>
          () => {
          }
      );
  }

  validateDoubleBookingClass(p_this, staffIds, callback) {


    this.removeStaffTimeSlotPeriod = [];

    if (staffIds != 'none') {
      var day = p_this.attr('day');
      var classId = p_this.attr('classId');
      var reqObj = {
        day: day,
        staffId: staffIds,
        starTime: p_this.attr('periodStart'),
        endTime: p_this.attr('periodEnd')
      };
      this.classManageService.getStaffScheduledByTime(reqObj, this.getAuthToken)
        .subscribe(
          async (data: any) => {
            if (data.status && data.schedule && data.schedule.length > 0) {
              var classText = data.schedule.length > 1 ? 'classes' : 'class';
              var classes = '';
              var time = '';
              var exist = false;
              var staffNames = [];
              var finalObj = {};
              data.schedule.forEach(function (s, i) {
                if (s.classId != classId) {
                  exist = true;
                  if (!finalObj[s.staffName]) {
                    finalObj[s.staffName] = [];
                  }
                  finalObj[s.staffName].push(s);
                }
              });

              var msg = '';
              for (var staff in finalObj) {
                var h = this;
                var classesNew = '';
                var timeNew = '';
                var day = '';
                var classArr = [];
                var subjectsArr = [];
                for (var j = 0; j < finalObj[staff].length; j++) {
                  var staffImage = finalObj[staff][j].staffImage;
                  h.staffImageToRemoveTimeSlot = staffImage;
                  var scheduleId = finalObj[staff][j].scheduleId;
                  h.removeStaffTimeSlotPeriod.push(finalObj[staff][j].scheduleId);
                  //h.removeStaffTimeSlotPeriod = scheduleId;
                  var splitTimeStart = finalObj[staff][j].periodStart.split(':');
                  var splitTimeEnd = finalObj[staff][j].periodEnd.split(':');
                  var m1 = momentJs();
                  m1.hours(splitTimeStart[0]);
                  m1.minutes(splitTimeStart[1]);
                  var m2 = momentJs();
                  m2.hours(splitTimeEnd[0]);
                  m2.minutes(splitTimeEnd[1]);

                  var comma = j > 0 ? ',' : '';
                  classesNew += comma + ' ' + finalObj[staff][j].classNumber + '' + finalObj[staff][j].classDivision;
                  timeNew += comma + ' ' + m1.format('h:mmA') + '-' + m2.format('h:mmA');
                  if (classArr.indexOf(finalObj[staff][j].classNumber + '' + finalObj[staff][j].classDivision) == -1) {
                    classArr.push(finalObj[staff][j].classNumber + '' + finalObj[staff][j].classDivision);
                  }
                  if (subjectsArr.indexOf(finalObj[staff][j].subject) == -1) {
                    subjectsArr.push(finalObj[staff][j].subject);
                  }
                  day = this.DAYS_KAMEL[finalObj[staff][j].day - 1];
                }
                h.showTimeslot = timeNew;
                h.showClass = classArr.join(',');
                classText = classArr.length > 1 ? 'classes' : 'class';
                const translation = await firstValueFrom(this.translate.get(['wasAlreadyScheduledToTeach', 'on', 'in', 'at']))
                var messageNew = `<span class="text-bold">${ staff }</span> ${translation['wasAlreadyScheduledToTeach']} <span class="text-bold">${subjectsArr.join(',')}</span> ${translation['on']} <span class="text-bold"> ${day} </span> ${translation['in']} `;
                messageNew = messageNew + '<span class="text-bold">' + classArr.join(',') + '</span> ' + classText+ ' ' + translation['at']+'  <span class="text-bold">' + timeNew + '</span>';
                msg += messageNew + '<br>';
              }
              if (h.staffImageToRemoveTimeSlot == '') {
                $('#staffimageforttimetble').attr('src', 'assets/img/class-category.png');
              } else {
                h.staffImageToRemoveTimeSlot = staffImage;
              }

              if (exist) {
                //p_this.val(h.copiedTimeTableSlotDataReset.subjectId)
                var staffReset = '<option value="none">NA</option>' + h.staffOptions[h.copiedTimeTableSlotDataReset.subjectId];
                p_this.parent().find('.timetable_teachers').html(staffReset);
                p_this.parent().find('.timetable_subjects').val(h.copiedTimeTableSlotDataReset.subjectId);
                p_this.parent().find('.timetable_teachers').val(h.copiedTimeTableSlotDataReset.staffId);
                h.openTimetableTimeClashPopup = true;
                h.fullMessageHTMLString = msg;
                h.showTimeSlotClashed = h.showTimeslot;
                h.showClassClashed = h.showClass;
                h.staffImageClashed = h.staffImageToRemoveTimeSlot;
                callback({
                  status: true,
                });
              } else {
                h.openTimetableTimeClashPopup = false;
                h.fullMessageHTMLString = '<div></div>';
                callback({
                  status: false,
                });
              }

            }
          },
          error =>
            async () => {
              this.openTimetableTimeClashPopup = false;
             const serverNotReachableTranslation = await firstValueFrom(this.translate.get('serverNotReachable')); 
             customToastr(serverNotReachableTranslation, 'error');
            }
        );
    }
  }

  cancelAction() {
    this.openTimetableTimeClashPopup = false;
  }

  /*loadClassesList(){
   $.ajax({url:'/getclassesofschool',type:'GET',success:function(results){
     classListInfo(results);
   },
     error : function (status) {
       const serverNotReachableToLoadClassListTranslation = await firstValueFrom(this.translate.get('serverNotReachableToLoadClassList')); customToastr(serverNotReachableToLoadClassListTranslation, 'error');
     }
   })
 }

   classListInfo(results){
     var classId = this.sectionId
   if(results != undefined && results.length>0) {
     for (var i = 0; i < results.length; i++) {
       $("#select-class-time").append($('<option/>',{value:results[i].classId,text:results[i].classNumber+' - '+results[i].classDivision}));
     }
     if(classId != undefined){
       $("#select-class-time").val(classId)
       this.getTimetable(classId)
     }
   }
   classId = undefined;
 }*/

  copyTimeTableSlot() {


    var h = this;
    $('body').on('click', '.copy-timetable-slot', function () {
      $('.paste-icon-color').show();
      h.copyEscape = true;
      $('#msghide').show();


      $('.copy-timetable-slot').hide();
      $('.paste-timetable-slot').removeClass('hide');
      $(this).parent().find('.paste-timetable-slot').addClass('hide');


      var subjectId = $(this).parent().find('.timetable_subjects').val();

      var staffId = $(this).parent().find('.timetable_teachers').val();


      h.copiedTimeTableSlotData.staffId = staffId;
      h.copiedTimeTableSlotData.subjectId = subjectId;
      $(this).parent().find('.timetable_teachers').val(staffId);


    });
  }


  pasteTimeTableSlot() {


    $('.paste-icon-color').show();
    var h = this;
    $('body').on('click', '.paste-timetable-slot', function (res) {


      var _this = $(this);

      /*var staffsReset = '<option value="none">NA</option>'+h.staffOptions[ _this.parent().find(".timetable_teachers").val()];
      _this.parent().find(".timetable_teachers").html(staffsRest);*/

      h.copiedTimeTableSlotDataReset.subjectId = _this.parent().find('.timetable_subjects').val();
      h.copiedTimeTableSlotDataReset.staffId = _this.parent().find('.timetable_teachers').val();


      var staffs = '<option value="none">NA</option>' + h.staffOptions[h.copiedTimeTableSlotData.subjectId];
      _this.parent().find('.timetable_teachers').html(staffs);

      $(this).parent().find('.timetable_subjects').val(h.copiedTimeTableSlotData.subjectId);
      $(this).parent().find('.timetable_teachers').val(h.copiedTimeTableSlotData.staffId);
      $(this).parent().find('.paste-icon-color').addClass('pasteicon-color-timetable-slot');
      var _dom = $(this).parent();
      //$(this).parent().find(".paste-timetable-slot").removeClass('hide');
      //$(".paste-timetable-slot").prop('disabled',true);
      h.validateDoubleBookingClass($(this).parent().find('.timetable_teachers'), h.copiedTimeTableSlotData.staffId, function (status) {
        //$(".paste-timetable-slot").prop('disabled', false);
        /*if(status == true){
          _dom.find(".timetable_subjects").val(h.copiedTimeTableSlotDataReset.subjectId);
          _dom.find(".timetable_teachers").val(h.copiedTimeTableSlotDataReset.staffId);
        }*/
      });


    });
  }


  async getTimetable(classId) {
    $('.copy-timetable-slot').hide();
    if (classId == 0) {
      const pleaseSelectClassAndSectionTranslation = await firstValueFrom(this.translate.get('pleaseSelectClassAndSection')); 
      customToastr(pleaseSelectClassAndSectionTranslation, 'error');
      const selectClassTranslation = await firstValueFrom(this.translate.get('selectClassToViewTimetable'));
      $('#timetable tbody').html(`<tr class="active"><td colspan="8">${selectClassTranslation}</td></tr>`);
       return;
    } else {
      var h = this;
      this.loadSubjects_class(classId, function (op) {
        h.staffOptions = op;
        h.classManageService.fetchTimeTableOfClass(classId, h.getAuthToken)
          .subscribe(
            (data: any) => {
              if (data && data.status && data.rows) {
                $('#timetable tbody').html('');
                h.isTimetableNotConfigured = false;
                $('#edit-timetable').show();
                h.dataRowForTranslations = data.rows;
                h.classIdForTranslations = classId;
                h.translate.get([
                  'subject',
                  'teacher',
                  'na',
                  'break',
                  'lunchBreak',
                  'subjectNotAssigned',
                  'teacherNotAssigned',
                  'currentlyRunning'
                ]).subscribe((translations) => {
                  h.bindTimetable(data.rows, classId, translations);
                })
                h.copyTimeTableSlot();
                h.pasteTimeTableSlot();
              } else {
                h.isTimetableNotConfigured = true;
                $('#saveTimetable').hide();
                $('#savettforupadte').hide();
                $('.edit-time-table').addClass('hide');
                $('#edit-timetable').hide();
                $('#timetable thead').find('[id^=timetablethday]').removeClass('hide');
                h.updateNotConfiguredTimeTableText();
              }
            },
            error => {
            }
          );
        /* $.ajax({
         url:'/gettimetableclass?classId='+classId,
         type:'GET',
         success:function(timetable){
         $("#timetable tbody").html("");
         if(timetable && timetable.status && timetable.rows){
         $("#edit-timetable").show();
         h.bindTimetable(timetable.rows,classId)
         }
         else{
         $("#edit-timetable").hide();
         $("#timetable thead").find('[id^=timetablethday]').removeClass('hide');
         $("#timetable tbody").html("<tr class='active'><td colspan='8'>Timetable configuration not exist for the class category. Please set configuration</td></tr>");
         }
         },
         error : function (status) {
         const serverNotReachableToLoadClassTimetableTranslation = await firstValueFrom(this.translate.get('serverNotReachableToLoadClassTimetable')); customToastr(serverNotReachableToLoadClassTimetableTranslation, 'error');
         }
         })*/
      });
    }


  }

  updateNotConfiguredTimeTableText() {
        this.translate.get('timeTableConfigurationNotExistForTheClassCategoryPleaseSetConfiguration').subscribe((translatedText: string) => {
            $('#timetable tbody').html(`<tr class="active"><td colspan="8">${translatedText}</td></tr>`);
        });
    }

  /*End of time table of class*/
  /*End of Time Table Module*/
  //token auth
  loginMode = '';

  isValidToken() {
    var isValidToken = false;
    var isValidSchool = 0;
    this.loginservice.isValidToken(localStorage.getItem('usertoken'))
      .subscribe(
        (data: any) => {
          isValidToken = data.isValid;
          if (data.errorcode == 10010) {
            this.router.navigate(['/suspended']);
          } else if (isValidToken == true) {
            this.loginservice.isValidSchoolId(localStorage.getItem('schoolinfo'))
              .subscribe(
                (data: any) => {
                  isValidSchool = data.schoolExist;
                  this.getSchoolId = localStorage.getItem('schoolinfo');
                  //this.schoolId=20;

                  if (isValidSchool != 1) {
                    this.router.navigate(['/login']);
                  } else if (this.loginMode == 'STAFF') {
                    this.router.navigate(['/exams']);
                  } else {
                    this.onPageLoad();
                    this.classManagementGetClassCategory();
                  }
                },
                error => {
                  console.error(error)
                }
              );
          } else {
            this.router.navigate(['/login']);
          }
        },
        error => {
          console.error(error)
        }
      );
  }

  onPageLoad() {
    /*   $('.particles-bg').particleground({
         dotColor: '#f3f3f3',
         lineColor: '#ffffff',
         lineWidth: .3
       });
       $('.particles-bg-main').particleground({
         dotColor: '#dadada',
         lineColor: '#ffffff',
         lineWidth: .3
       });*/

    //disable clicks
    $('.tab-timetable').children().unbind('click');
    $('.timetable-tab').children().unbind('click');
  }

  async updateSelectClassTable() {
     const selectClassTranslation = await firstValueFrom(this.translate.get('selectClassToViewTimetable'));
    $('#timetable tbody').html(`<tr class="active"><td colspan="8">${selectClassTranslation}</td></tr>`);
  }


   ngOnInit() {

    this.loginMode = localStorage.getItem('loginMode');
    if (this.loginMode == 'STAFF') {
      this.router.navigate(['/exams']);
    }
    var h = this;
    this.scriptLoader.loadScript($, 'CLASSES');
   
    h.updateSelectClassTable();
    $('body').on('change', '.timetable_subjects', function () {
      var subjectId = $(this).val();
      var classId = $(this).attr('classId');
      var _this = $(this);
      $('#saveTimetable').show();
      $('#savettforupadte').show();
      if (subjectId != 'none') {
        var staffs = '<option value="none">NA</option>' + h.staffOptions[subjectId];
        _this.parent().find('.timetable_teachers').html(staffs);
        _this.parent().find('.timetable_teachers').val('none');
      } else {
        _this.parent().find('.timetable_teachers').html('<option value="none">NA</option>');
        _this.parent().find('.timetable_teachers').val('none');


        /* var staffResetValue = '<option value="none">NA</option>'+h.staffOptions[h.copiedTimeTableSlotDataReset.subjectId];
         _this.parent().find(".timetable_teachers").html(staffResetValue);
         _this.parent().find(".timetable_subjects").val(h.copiedTimeTableSlotDataReset.subjectId);
         _this.parent().find(".timetable_teachers").val(h.copiedTimeTableSlotDataReset.staffId);*/
      }
    });


    $('body').on('change', '.timetable_teachers', function (res) {
      var staffId = $(this).val();
      var classId = $(this).attr('classId');
      var p_this = $(this);
      $('#saveTimetable').show();
      $('#savettforupadte').show();
      if (staffId != 'none') {
        h.copiedTimeTableSlotDataReset.staffId = 'none';
        h.copiedTimeTableSlotDataReset.subjectId = p_this.parent().find('.timetable_subjects').val();

        h.validateDoubleBookingClass(p_this, staffId, function (status) {
        });
      } else {
        p_this.val('none');
      }
    });

    var adminPermissionlist = localStorage.getItem('adminPermissionlist');
    if (adminPermissionlist) {
      var list = JSON.parse(adminPermissionlist);
      this.permissions = list;
    }
    this.timeTableSetting();
    this.categoryInfoTimeTable();
    this.timeTableConfig();
    this.isValidToken();
    /*$('#subjectAdd').click(function () {
      $('#addNewSubject').show();
      $('#addSubject').hide();
    });*/
    $('#canceladdSubject').click(function () {
      $('#addNewSubject').hide();
      $('#addSubject').show();
    });
    $('#addnewteacher').click(function () {
      $('#addNewClassTeacher').show();
      $('#search-staff-assign').val('');
    });
    $('#sequence-class').click(function () {
      $('#classList').hide();
      $('#updateClassSequenceOrder').show();
    });
    $('.cancelupdateorder').click(function () {
      $('#classList').show();
      $('#updateClassSequenceOrder').hide();
    });
    $('#sequence-section').click(function () {
      $('#updateSectionSequence').show();
      $('#section-List').hide();
    });
    $('.cancelSectionorder').click(function () {
      $('#updateSectionSequence').hide();
      $('#section-List').show();
    });
    $('#addSubjectButton').click(function () {
      $('#add-new-subject').show();
      $('#addSubjectNew').hide();
    });
    $('#canceladdnewSubject').click(function () {
      $('#add-new-subject').hide();
      $('#addSubjectNew').show();
    });
    $('#addTimeTable').click(function () {
      $('#saveTimetableConfig').show();
      $('#configureTimeTable').show();
      $('#timetableslots').hide();
    });
    $('#cancelTimeTable').click(function () {
      $('#configureTimeTable').hide();
      $('#timetableslots').show();
    });

    this.langChangeSubscription = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      $.fn.dataTable.ext.errMode = 'none';
      this.updateSelectClassTable();
      this.destroyDataTable('categoryview-detail-table');
       this.destroyDataTable('subject-List-table');
      this.destroyDataTable('classview-detail-table');


      this.initializeDataTable('categoryview-detail-table');    
      this.initializeDataTable('subject-List-table');
      this.initializeDataTable('classview-detail-table');
      this.initializeDataTable('view-class-detail-student-table');
      this.initializeDataTable('class-standard-table');
      this.initializeDataTable('assignSubjectStudentTable');
      this.initializeDataTable('class-category-table');
      this.initializeDataTable('categoryviewdetail');
      if  (this.isTimetableNotConfigured === true) { 
        this.updateNotConfiguredTimeTableText(); 
      } else {
        this.translate.get([
          'subject',
          'teacher',
          'na',
          'break',
          'lunchBreak',
          'subjectNotAssigned',
          'teacherNotAssigned',
          'currentlyRunning'
        ]).subscribe((translations) => {
          this.bindTimetable(this.dataRowForTranslations, this.classIdForTranslations, translations);
        });
      }
      
    
      });

  }

  /* Class classTeacher tab start*/
  openClassTeacherAssign() {

  }

  /* Class classTeacher tab end*/

  isProcessing = false;

  async addMoreSubjectsToClass() {
    this.subjectListNotInClass = [];
    var sectionId = $('#selectSectionId').val();
    if (sectionId && sectionId != '' && sectionId != 0) {
      this.isProcessing = true;
      this.selectedClassId = sectionId;
      this.sectionId = sectionId;
      $('#open-assign-subject-to-class-popup').trigger('click');
      this.classManageService.getSubjectsNotInClass(this.selectedClassId, localStorage.getItem('usertoken'))
        .subscribe(
          (data: any) => {
            this.isProcessing = false;
            this.subjectListNotInClass = data;
          },
          error => {
            this.subjectListNotInClass = [];
            this.isProcessing = false;
          }
        );
    } else {
      const pleaseSelectSectionTranslation = await firstValueFrom(this.translate.get('pleaseSelectSection')); 
      customToastr(pleaseSelectSectionTranslation, 'error');
    }

  }

  truncateText(text, length) {
    if (text && text.length > length) {
      return text.substr(0, length) + '..';
    }
    return text;
  }

  editclassTeacherPopUp(staff) {
    this.editClassTeacher = staff;
  }

  /*STUDENT SUBJECT ASSIGN START*/
  studentListForSubject = [];
  studentAssignStatus = false;
  studentAssignNoData = false;
  studentAssignData = false;
  selectAllForAssignStudent = false;
  getSubjectIdForStudentAssign;

  getStudentListOfSubjectAssign(subjectId) {
    this.getSubjectIdForStudentAssign = subjectId;
    this.studentAssignStatus = true;
    this.studentAssignNoData = false;
    this.studentAssignData = false;
    this.studentListForSubject = [];
    this.destroyDataTable('assignSubjectStudentTable');
    this.classManageService.studentSubjectAssignListService(this.selectedClassId, subjectId, this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.studentAssignStatus = false;
          this.studentListForSubject = data;
          if (this.studentListForSubject.length > 0) {
            this.studentAssignNoData = false;
            this.studentAssignData = true;
            this.initializeDataTable('assignSubjectStudentTable');
          } else {
            this.studentAssignNoData = true;
            this.studentAssignData = false;
          }

        },
        async error => {
          this.studentAssignStatus = false;
          this.studentAssignNoData = false;
          this.studentAssignData = false;
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }

  applyAllForAssignStudent() {
    if (this.selectAllForAssignStudent) {
      for (let i = 0; i < this.studentListForSubject.length; i++) {
        this.studentListForSubject[i].studentSubjectStatus = true;
      }
    } else {
      for (let j = 0; j < this.studentListForSubject.length; j++) {
        this.studentListForSubject[j].studentSubjectStatus = false;
      }
    }
  }

  checkAllSelected() {
    let studentListLength = [];
    for (let i = 0; i < this.studentListForSubject.length; i++) {
      if (this.studentListForSubject[i].studentSubjectStatus == true) {
        studentListLength.push({ studentId: this.studentListForSubject[i].studentId });
      }
    }
    if (studentListLength.length == this.studentListForSubject.length) {
      this.selectAllForAssignStudent = true;
    } else {
      this.selectAllForAssignStudent = false;
    }
  }

  async assignSubjectToStudent() {
    let removeStudentFromSubject = [];
    let addStudentToAssignSubject = [];
    for (let i = 0; i < this.studentListForSubject.length; i++) {
      if (this.studentListForSubject[i].pkStudentSubjectId && this.studentListForSubject[i].studentSubjectStatus == false) {
        removeStudentFromSubject.push({
          pkStudentSubjectId: this.studentListForSubject[i].pkStudentSubjectId,
          studentId: this.studentListForSubject[i].studentId,
          subjectId: this.getSubjectIdForStudentAssign, classId: this.selectedClassId
        });
      } else if (this.studentListForSubject[i].pkStudentSubjectId == null && this.studentListForSubject[i].studentSubjectStatus == true) {
        addStudentToAssignSubject.push({
          studentId: this.studentListForSubject[i].studentId,
          subjectId: this.getSubjectIdForStudentAssign, classId: this.selectedClassId
        });
      }
    }
    if (addStudentToAssignSubject.length == 0 && removeStudentFromSubject.length == 0) {
      const pleaseDoSomeChangesTranslation = await firstValueFrom(this.translate.get('pleaseDoSomeChanges')); 
      customToastr(pleaseDoSomeChangesTranslation, 'error');
      return;
    }
    let studentData = {
      removeStudentFromSubject: removeStudentFromSubject,
      addStudentToAssignSubject: addStudentToAssignSubject
    };
    $('#assignSubjectToStudentButton').attr('disabled', true);
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $('#assignSubjectToStudentButton').text(translatedText); });
    this.classManageService.addOrRemoveStudentFromSubjectService(studentData, this.getAuthToken)
      .subscribe(
        async (data: any) => {
          $('#assignSubjectToStudentButton').attr('disabled', false);
          this.translate.get('save').subscribe((translatedText: string) => { $('#assignSubjectToStudentButton').text(translatedText); });
          if (data.status) {
            const studentSuccessfullyAssignedRemovedToSubjectTranslation = await firstValueFrom(this.translate.get('studentSuccessfullyAssignedRemovedToSubject')); 
            customToastr(studentSuccessfullyAssignedRemovedToSubjectTranslation, 'success');
          } else {
            const someErrorPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('someErrorPleaseTryAgain')); 
            customToastr(someErrorPleaseTryAgainTranslation, 'error');
          }
        },
        async error => {
          $('#assignSubjectToStudentButton').attr('disabled', false);
          this.translate.get('save').subscribe((translatedText: string) => { $('#assignSubjectToStudentButton').text(translatedText); });
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }

  /*STUDENT SUBJECT ASSIGN END*/

  initiateOrderClassStandards() {
    this.enableClassSequence = true;
    // this.classesListToDrag = JSON.parse(JSON.stringify(this.getClassListArray));
  }
  initiateSectionOrder() {
    this.enableSectionSequence = true;
  }

  async validateSectionOrder(section, index) {
    let sequence = section.SectionSequence
    if (sequence) {
      sequence = parseInt(sequence);
      if (isNaN(sequence)) {
        const sequenceMustBeANumberTranslation = await firstValueFrom(this.translate.get('sequenceMustBeANumber')); 
        customToastr(sequenceMustBeANumberTranslation, 'error');
        section.SectionSequence = null;
        return;
      }
      if (section.SectionSequence <= 0) {
        const sectionSequenceShouldBeGreaterThanZeroTranslation = await firstValueFrom(this.translate.get('sectionSequenceShouldBeGreaterThanZero')); 
        customToastr(sectionSequenceShouldBeGreaterThanZeroTranslation, 'error');
        section.SectionSequence = null;
        return;
      }
      if (section.SectionSequence > this.getClassViewClassSectionArray.length) {
        const maxSections = this.getClassViewClassSectionArray.length;

        const translation = await firstValueFrom(
          this.translate.get('sectionSequenceShouldNotBeMoreThan', { maxSections })
        );

        customToastr(translation, 'error');
        section.SectionSequence = null;
        return;
      }
    }
    else {
      const sectionSequenceNumberIsRequiredTranslation = await firstValueFrom(this.translate.get('sectionSequenceNumberIsRequired')); 
      customToastr(sectionSequenceNumberIsRequiredTranslation, 'error');
    }

  }
  async validateClassOrder(classObj, index) {
    let sequence = classObj.Sequence;
    if (sequence) {
      sequence = parseInt(sequence);
      if (isNaN(sequence)) {
        const classSequenceMustBeANumberTranslation = await firstValueFrom(this.translate.get('classSequenceMustBeANumber')); 
        customToastr(classSequenceMustBeANumberTranslation, 'error');
        classObj.Sequence = null;
        return;
      }
      if (classObj.Sequence <= 0) {
        const classSequenceShouldBeGreaterThanZeroTranslation = await firstValueFrom(this.translate.get('classSequenceShouldBeGreaterThanZero')); 
        customToastr(classSequenceShouldBeGreaterThanZeroTranslation, 'error');
        classObj.Sequence = null;
        return;
      }
      if (classObj.Sequence > this.getClassListArray.length) {
        const maxClasses = this.getClassListArray.length;

        const translation = await firstValueFrom(
          this.translate.get('classSequenceShouldNotBeMoreThan', { maxClasses })
        );

customToastr(translation, 'error');
        classObj.Sequence = null;
        return;
      }
    }
    else {
      const classSequenceNumberIsRequiredTranslation = await firstValueFrom(this.translate.get('classSequenceNumberIsRequired')); 
      customToastr(classSequenceNumberIsRequiredTranslation, 'error');
    }

  }

  initiateSectionDrag(standardObj) {
    $("#sortSectionsHead").focus();
    if (!standardObj.sectionsList) {
      this.classManageService.getClassSectionListService(this.getSchoolId, standardObj.fkClassStandardsId, this.getAuthToken)
        .subscribe(
          (data: any) => {
            standardObj.sectionsList = data;
            this.sectionsListToDrag = standardObj.sectionsList;
            this.standardIdSelectedToDrag = standardObj.fkClassStandardsId;
          },
          async error => {
            $('#assignSubjectToStudentButton').attr('disabled', false);
            this.translate.get('save').subscribe((translatedText: string) => { $('#assignSubjectToStudentButton').text(translatedText); });
            const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
            customToastr(internalServerErrorTranslation, 'error');
          }
        );
    }
    else {
      this.sectionsListToDrag = standardObj.sectionsList;
      this.standardIdSelectedToDrag = standardObj.fkClassStandardsId;
    }
  }

  classDropped(event: CdkDragDrop<any[]>) {
    this.classesListToDrag[event.previousIndex].isDragging = false;
    moveItemInArray(this.classesListToDrag, event.previousIndex, event.currentIndex);
  }

  dropListItemMoveStart(classObj, index) {
    classObj.isDragging = true;
    for (let i = 0; i < this.classesListToDrag.length; i++) {
      this.classesListToDrag[i].isDragging = (i === index);
    }
  }

  saveClassesOrder(list) {
  }

  classSectionsDropped(event: CdkDragDrop<any[]>) {
    this.sectionsListToDrag[event.previousIndex].isDragging = false;
    moveItemInArray(this.sectionsListToDrag, event.previousIndex, event.currentIndex);
  }

  dropSectionListItemMoveStart(sectionObj, index) {
    sectionObj.isDragging = true;
    for (let i = 0; i < this.sectionsListToDrag.length; i++) {
      this.sectionsListToDrag[i].isDragging = (i === index);
    }
  }

  saveSectionsOrder(list) {
    this.sectionsListToDrag = [];
  }
  setActive(tab: string) {
    this.searchValue = ''
    this.activeTab = tab;
  }

  handleGlobalAttendanceConfig(tab: string) {
    if (this.globalAttendanceConfigurationStatusData !== tab) {
      this.attendanceType = tab
      this.showGlobalAttendanceConfirmModal = true;
    }
  }

  handleGlobalAttendanceSwitch() {
    this.changeAttendanceTypeForAllClass(this.attendanceType);
  }
  async handleClassWiseAttendanceConfig(attendanceDetails: any, tab: string) {
    if (attendanceDetails.attendanceType !== tab) {
      if (attendanceDetails.isTimeTableConfigured === 0 && tab === this.strings.PERIOD) {
        const timetableIsNotConfiguredMessageTranslation = await firstValueFrom(this.translate.get('timetableIsNotConfiguredMessage')); 
        customToastr(timetableIsNotConfiguredMessageTranslation, this.registrationStrings.errorCode);
      } else {
        if (tab === this.strings.PERIOD) {
          attendanceDetails.periodLoader = true;
        } else if (tab === this.strings.DAY) {
          attendanceDetails.dayLoader = true;
        }
        const previousType = attendanceDetails.attendanceType;
        attendanceDetails.attendanceType = tab.toLocaleUpperCase();
        this.changeAttendanceTypeForParticularClass(attendanceDetails.attendanceType, attendanceDetails.classId).then(() => {
          if (tab === this.strings.PERIOD) {
            attendanceDetails.periodLoader = false;
          } else if (tab === this.strings.DAY) {
            attendanceDetails.dayLoader = false;
          }
        }).catch(() => {
          if (tab === this.strings.PERIOD) {
            attendanceDetails.periodLoader = false;
          } else if (tab === this.strings.DAY) {
            attendanceDetails.dayLoader = false;
          }
          attendanceDetails.attendanceType = previousType;
        });
      }

    }
  }

  handelOnBlurSearch(): void {
    if (!this.searchValue) {
      this.isSearchActive = false;
      this.filterClassDetails = [...this.classAttendanceDetails];
    }
  }

  async getClassListWithAttendanceType() {
    try {
      this.loader = true;
      const response = await firstValueFrom(this.classManageService.getClassListWithAttendanceTypeApi());
      const responseDetails = response as any;
      if (responseDetails.status) {
        if (responseDetails.body && responseDetails.body.classAttendanceTypeConfigurationListData) {
          this.classAttendanceDetails = responseDetails.body.classAttendanceTypeConfigurationListData;
          this.filterClassDetails = this.classAttendanceDetails;
          this.globalAttendanceConfigurationStatusData = responseDetails.body.currentAttendanceConfigurationStatusData.length > 0 ? responseDetails.body.currentAttendanceConfigurationStatusData[0].attendanceTypeStatus : "";
          this.searchValue = "";
        }
      } else {
        this.classAttendanceDetails = []
        this.searchValue = "";
        customToastr(responseDetails.message, this.registrationStrings.errorCode);
      }
      this.loader = false;
    } catch (error) {
      this.classAttendanceDetails = []
      if (error.error.status_code !== 404) {
        const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage'));
        customToastr(error
          ? error.error
            ? error.error.message
            : errorMessageTranslation
          : errorMessageTranslation,
          this.registrationStrings.errorCode);
      }
      this.searchValue = ""
      this.loader = false;
    }
  }
  handleAttendanceDetails() {
    this.getClassListWithAttendanceType()
  }

  async changeAttendanceTypeForParticularClass(attendanceType: string, classId: string) {
    try {
      this.individualAttendanceLoader = true;
      const body = {
        lang: "en",
        attendanceType: attendanceType,
        classId: classId
      }
      const response = await firstValueFrom(this.classManageService.changeAttendanceTypeForParticularClassApi(body));
      const responseDetails = response as any;
      if (responseDetails.status) {
        if (responseDetails.body) {
          customToastr(responseDetails.body.message, this.registrationStrings.successCode);
          this.getClassListWithAttendanceType()
        }
      } else {
        customToastr(responseDetails.message, this.registrationStrings.errorCode);
      }
      this.individualAttendanceLoader = false;
    } catch (error) {
      const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage'));
      customToastr(error
        ? error.error
          ? error.error.message
          : errorMessageTranslation
        : errorMessageTranslation,
        this.registrationStrings.errorCode);
      this.individualAttendanceLoader = false;
    }
  }


  async changeAttendanceTypeForAllClass(attendanceType: string) {
    try {
      this.globalAttendanceLoader = true;
      const body = {
        lang: "en",
        attendanceType: attendanceType
      }
      const response = await firstValueFrom(this.classManageService.changeAttendanceTypeForAllClassApi(body));
      const responseDetails = response as any;
      if (responseDetails.status) {
        if (responseDetails.body) {
          customToastr(responseDetails.body.message, this.registrationStrings.successCode);
          this.getClassListWithAttendanceType();
          this.closePopup()
        }
      } else {
        customToastr(responseDetails.message, this.registrationStrings.errorCode);
        this.closePopup()
      }
      this.globalAttendanceLoader = false;
    } catch (error) {
      const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage'));
      customToastr(error
        ? error.error
          ? error.error.message
          : errorMessageTranslation
        : errorMessageTranslation,
        this.registrationStrings.errorCode);
      this.closePopup()
      this.globalAttendanceLoader = false;
    }
  }

  filterClassDetailsData() {
    if (this.searchValue) {
      const searchLower = this.searchValue.toLowerCase();
      clearTimeout(this.searchDebounceValue);
      this.searchDebounceValue = setTimeout(() => {
        this.filterClassDetails = this.classAttendanceDetails.filter((item: { classNumber: string; classDivision: string; classTeacherName: string; }) => {
          const combinedClass = `${item.classNumber} - ${item.classDivision}`.toLowerCase();
          return combinedClass.includes(searchLower) ||
            item.classDivision.toLowerCase().includes(searchLower) ||
            item.classNumber.toLowerCase().includes(searchLower)
            || (item.classTeacherName ? item.classTeacherName.toLowerCase().includes(searchLower) : false)
        });
      }, 800)
    } else {
      clearTimeout(this.searchDebounceValue);
      this.filterClassDetails = [...this.classAttendanceDetails];
    }
  }

  closePopup() {
    this.showGlobalAttendanceConfirmModal = false;
  }
}
